import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Location } from '@angular/common';
import {
  AfterViewInit,

  Component,
  ElementRef, EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { PagesLoadedEvent, pdfDefaultOptions } from "ngx-extended-pdf-viewer";
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';
import { DocumentEntity } from 'src/app/core/class/DocumentEntity';
import { Message } from 'src/app/core/class/message';
import { EnumContractEnterpriseStatus, EnumContractStatus } from 'src/app/core/constants/contract';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { ApiService } from 'src/app/core/services/api.service';
import Utils from 'src/app/core/services/app-utils';
import { CommonService } from 'src/app/core/services/common.service';
import { ContractService } from 'src/app/core/services/contract.service';
import { CreateContractMohaService } from 'src/app/core/services/create-contract-moha.service';
import { DocumentTemplateService } from 'src/app/core/services/document-template.service';
import { DocumentService } from 'src/app/core/services/document.service';
import { EnvService } from 'src/app/core/services/env.service';
import FileUtils, { ContentType } from 'src/app/core/services/file-utils';
import { HandsontableService } from 'src/app/core/services/handsontable.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { Field } from 'src/app/shared/models/field.model';
import * as uuid from 'uuid';
import { SetupInternalSigningFlowComponent } from '../../add-document/general-form-info/setup-internal-signing-flow/setup-internal-signing-flow.component';
import { DisplayTemplateComponent } from '../../display-template/display-template.component';
import { PanelDocumentViewComponent } from "../../panel-document-view/panel-document-view.component";
import { PanelDocumentComponent } from '../../panel-document/panel-document.component';
import { FootNoteMohaComponent } from '../document-form-moha/footnote-moha/footnote-moha.component';
import { GeneralFormInfoMohaComponent } from '../general-form-info-moha/general-form-info-moha.component';
import { RecordPartySignMohaComponent } from '../record-party-sign-moha/record-party-sign-moha.component';

const FormActionType = 0;
const FileUploadType = 1;
declare var $: any;

@Component({
  selector: "app-preview-contract-document-view-moha",
  templateUrl: "./preview-contract-document-view-moha.component.html",
  styleUrls: ["./preview-contract-document-view-moha.component.scss"],
})
export class PreviewContractDocumentViewMohaComponent
  extends BaseComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @BlockUI() blockUI: NgBlockUI;
  selectFile: any;
  isCheckFile: boolean = true
  totalPage: any;
  signatureSelected = null;
  signatureNeedShow = null;
  isOnAutoNumber: boolean = false;
  configAutoNumber: string;
  refreshContractCode = false;
  selectedFile: any = '';
  selectedFileSign: any = 0;
  isUpdate: any = false;
 listDataApro = [{
  order: 2,
  userId: "NWE0ZmQkaHNBKjY4MzU2",
  enterpriseSignId: undefined,
  name: "admin",
  email: "admin@gmail.com",
  role: "1",
  phone: "0325873042",
  isCreatedSide: false,
},{
  order: 2,
  userId: "NWE0ZmQkaHNBKjY4MzU2",
  enterpriseSignId: undefined,
  name: "admin",
  email: "admin@gmail.com",
  role: "1",
  phone: "0325873042",
  isCreatedSide: false,
}
];
 listDataSign1 = [{
  order: 2,
  userId: "NWE0ZmQkaHNBKjY4MzU2",
  enterpriseSignId: undefined,
  name: "admin",
  email: "admin@gmail.com",
  role: "1",
  phone: "0325873042",
  isCreatedSide: false,
},{
  order: 2,
  userId: "NWE0ZmQkaHNBKjY4MzU2",
  enterpriseSignId: undefined,
  name: "admin",
  email: "admin@gmail.com",
  role: "1",
  phone: "0325873042",
  isCreatedSide: false,
}
];
  @Output() changePrintf: EventEmitter<any> = new EventEmitter<any>();
  @Input() maxSize: number = 10485760;
  @Input() documentTypeEnterprise: any;
  maxSizeError: string = ''
  documentCodeNull = false;
  userLoginId: string;
  isSetUpSignFlow: boolean = false;
  constructor(
    private apiService: ApiService,
    private el: ElementRef,
    public commonService: CommonService,
    private documentService: DocumentService,
    public message: Message,
    public toastr: ToastrService,
    private route: ActivatedRoute,
    public notificationService: NotificationService,
    private contractService: ContractService,
    private router: Router,
    private dialog: MatDialog,
    private _location: Location,
    private createContractMohaService: CreateContractMohaService,
    private translateService: TranslateService,
    private documentTemplateService: DocumentTemplateService,
    private handsontableService: HandsontableService,
    private env: EnvService
  ) {
    super(commonService, message);
    this.flagCopy = this.route.snapshot.queryParams.flagCopy;
    this.language = localStorage.getItem("__language") || "vi";
    this.userLoginId = localStorage.getItem('userId');
    // set menu trái là default Collapsed khi vào màn Lập hợp đồng
    // localStorage.setItem(this.SIDEBAR_CURRENT_STATUS, this.COLLAPSED);
    pdfDefaultOptions.renderInteractiveForms = false;
    this.isUpdate = this.route.snapshot.queryParams && (this.route.snapshot.queryParams.typeUpdate || (this.route.snapshot.queryParams.goFrom == 'hdld' && !this.route.snapshot.queryParams.flagCopy));
    if(this.route.snapshot.queryParams.goFrom == 'negotiate'){
      this.routeLink = '/home-enterprise/search-negotiate-document'
    }
  }
  renderSignOnce: number = 0;
  public isShowReferencePdf = false;
  public language: string;
  maxPageCurrent;
  @ViewChild(PanelDocumentComponent, {
    read: PanelDocumentComponent,
    static: true,
  })
  panelDocumentComponent;

  @ViewChild(DisplayTemplateComponent, {
    read: DisplayTemplateComponent,
    static: false,
  })
  displayTemplateComponent;

  @ViewChild('footNote', {
    static: true
  })
  public footNote: FootNoteMohaComponent;
  @ViewChild(GeneralFormInfoMohaComponent, {
    read: GeneralFormInfoMohaComponent,
    static: true
  }) generalFormInfoMohaComponent: GeneralFormInfoMohaComponent;

  @ViewChild(PanelDocumentViewComponent, {read: PanelDocumentViewComponent, static: true}) panelDocumentViewComponent;

  @ViewChild(RecordPartySignMohaComponent, {
    read: RecordPartySignMohaComponent,
    static: true
  }) recordPartySignMohaComponent: RecordPartySignMohaComponent;
  submit = new Subject();

  documentType: string;

  document: DocumentEntity;

  warningContractQuantity = false;


  currentTab = 0;

  // List cities
  cities: { id: number; name: ""; description: "" }[];

  // List districts
  districts: { id: number; cityId: number; name: ""; description: "" }[];

  // List wards
  wards: { id: number; districtId: number; name: ""; description: "" }[];

  // Id of current enterprise
  enterpriseId = localStorage.getItem("enterpriseId");

  // Default address of enterprise
  defaultAddress = {
    cityId: null,
    districtId: null,
    wardId: null,
    enterpriseId: null,
    address: "",
  };

  // Default enterprise's information
  defaultEnterprises = {
    id: null,
    name: "",
    enterpriseType: null,
    tenantId: 1,
    foreignName: "",
    parentId: null,
    abbreviation: "",
    taxCode: "",
    licenceDate: null,
    activeDate: null,
    phone: "",
    fax: "",
    primaryEmail: "",
    email: "",
    certificateId: null,
    certificateNo: "",
    issuedDate: null,
    issuedAt: "",
    expiryDate: null,
    accountNumber: "",
    bankName: "",
    bankBranch: "",
    representative: "",
    position: "",
    representativeCertificateId: null,
    representativeCertificateNo: "",
    representativeIssuedDate: null,
    representativeIssuedOn: "",
    status: true,
    version: null,
    birthday: null,
    sex: "",
    files: [],
    adminUser: "",
    addresses: [this.defaultAddress],
    attachments: [],
    parentName: "",
  };

  // Enterprise information
  enterprise = this.defaultEnterprises;

  // grab response data.
  documentTemplate = "";
  // Data for binding to template, when updating, this variable will receive the document data
  documentData: any;
  // Default data for binding to template, when updating, this variable will not be used
  defaultDocumentData: any;

  // searching paging.
  page: number;
  pageSize: number;
  currentPage: number;
  routeLink: string = "";
  enterpriseSearch: "";
  documentTypeSearch: "";
  nameOrCode: "";
  customerName: "";
  status: "";
  serviceType: "";
  taxCode: "";
  createdUser: "";
  createdTimeFrom: "";
  createdTimeTo: "";
  finishDateFrom: "";
  finishDateTo: "";
  sortDirection: "";
  sortColumn: "";
  openSelected: number;
  selectedNumberPage: number;
  listSignature: any[] = [];
  listFont = [
    { name: 'Roboto', value: 'Roboto' }
  ];
  listSignatureTable: any[] = [];
  listSignatureHeadRows: any[] = [];
  // control buttions.
  flagCopy: any;
  typeCopy: any;
  EventWarningContractSubscription;
  subscriptions: Subscription = new Subscription();

  /**
   * Flag for change detection in CanDeactivate
   */
  show = true;

  documentId = "";
  isShowMatRaised = "";

  // Check for form change
  isFormChanging = true;

  // Check is page from page view document
  pageView = false;

  /**
   * Url check error duplicate document code
   */
  urlApiDocumentUpload = "/contract/file";
  urlApiDocumentForm = "/contract";
  // Refresh input file
  @ViewChild("inputUpload", { read: "", static: false })
  inputUploadFile: ElementRef;

  // Button upload
  @ViewChild("btnUpload", { read: "", static: false }) btnUpload: ElementRef;

  // Button form
  @ViewChild("btnForm", { read: ElementRef, static: false })
  btnForm: ElementRef;
  private serviceTypeEntity: any;
  // public pdfSrc: string;
  @Input() pdfSrc: string;
  loadSign=true;
  oldPdfSrc: string;
  isVisible = true;

  SIDEBAR_CURRENT_STATUS = "SidebarCurrentStatus";
  COLLAPSED = "Collapsed";
  isHide = false;
  @Input() selectForm: boolean;
  listDataSign = { enterprise: [], customer: [] };
   listApproverSign: any;
  checkMan: any;
  @Input() MY_DOCUMENT_ROUTER_ON_BACK_LINK: any;
  @Input() receivedTimeFrom: any;
  @Input() receivedTimeTo: any;
  @Input() signRole: any;
  @Input() nameOrEmailOrPhoneUserSign: any;
  @Input() senderName: any;
  @Input() listDataDocument: any;
  @Input() idDocument: any;
  listDataPopup:any;
  listDataPopupOld:any;
  dataPopup:any = [];
  dataPopup1:any = [];
  dataPopup2:any = [];
  limitRun = 0;

  createContractType = null;

  zoomLevel = 100;

  isSelectPosition = false;
  stopDrop = true;
  stopClose = true;
  currentNodeSelected = null;
  checkUSerCreateContract: boolean = false;
  private stampWrapper: HTMLDivElement;
  widthRectangle = 300;
  heightRectangle = 136;
  widthRectangleSignature = 170;
  heightRectangleSignature = 70;
  pageIndex = 1;

  listSign = [];
  listUserNoSign:any;
  signSelected = null;

   // listDataSign = { enterprise: [], customer: [] };
  // listApproverSign = [];

  tabMode: 'hide' | 'info' | 'sign' = 'info';

  signNeedShow: null;
  signApproverNeedShow: null;

  isMouseLeave: boolean = false;
  public listPdfSrc = {};
  BASE_URL = 'http://localhost:8091/api';
  authorization: any
  @ViewChild('navigation', { static: false }) navigation: ElementRef;

  signaturesFormPositions: any = [];
  isSetSignFlow:any;
  enumContractStatus = EnumContractStatus;
  enumContractEnterpriseStatus = EnumContractEnterpriseStatus;

  fileUploads: File[] = [];
  activeFile: number = 0;
  maxSizeSystem: number = 0;
  biggerThan10MBFileSize: number;
  fileUploadSize: number = 0;
  size10MB = 10*1024*1024;
  size150MB = 150*1024*1024;

  isHaveUserSign = true;

  selected = new FormControl('TIMES_ROMAN', []);
  @HostListener('submit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll(
      ".mat-form-field-invalid .mat-input-element,.mat-select-invalid"
    );
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }

  /**
   * Init the component.
   */
  ngOnInit() {
    localStorage.removeItem('procedureIdActive');
    this.authorization = {
      Authorization: `Bearer ${sessionStorage.getItem('token')}`
    }
    this.BASE_URL = this.env.is_private_app ? this.env.private_api_endpoint : this.env.public_api_endpoint;
    this.BASE_URL += '/file/view/contract'
    this.initFormData();
    this.loadAddresses();
    this.addEventsCheckFormChange();
    this.apiService.addUrlToHandlingErrorRestApisPut(this.urlApiDocumentForm);
    this.apiService.addUrlToHandlingErrorRestApis(this.urlApiDocumentForm);
    this.apiService.addUrlToHandlingErrorRestApisPut(this.urlApiDocumentUpload);
    this.apiService.addUrlToHandlingErrorRestApis(this.urlApiDocumentUpload);
    this.subscribeValue();
    this.changeDataToTable();
    this.maxSizeError = this.message.getMessage('validation.validate_file_type_file_size_config').replace('{0}', String(Math.floor(this.biggerThan10MBFileSize >= 0 ? this.maxSizeSystem / 1024 / 1024 : this.size10MB / 1024 / 1024)))
    this.isShowMatRaised =
      this.createContractMohaService.createContractType.getValue() === 1
        ? "local"
        : this.createContractMohaService.createContractType.getValue() === 0
          ? "server"
          : "";
    document.addEventListener('mouseup', (eventMouseUp) => {
      if (this.isSelectPosition && this.isMouseLeave) {
        this.returnToPrevPosition();
        this.returnToPrevPositionSignContract();
      }
    });
    this.panelDocumentViewComponent.isShowReferencePdf.asObservable().subscribe((data) => {
      this.isShowReferencePdf = data;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectForm) {
      const listBtn = document.querySelectorAll("button");
      if (this.selectForm) {
        listBtn.forEach((btn) => {
          if (btn.className.includes('mat-stroked-button-create-document')) {
            btn.classList.add("btn_glowing");
          }
        });
        setTimeout(() => {
          listBtn.forEach((btn) => {
            btn.classList.remove("btn_glowing");
          });
        }, 5000);
      }
    }
    // this.isShowMatRaised = (this.createContractMohaService.createContractType.getValue() === 1) ? 'local' : ((this.createContractMohaService.createContractType.getValue() === 0) ? 'server' : '');
  }
  private getBase64File(file: Blob): any {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => { resolve(reader.result); };
      reader.readAsDataURL(file);
    });
  }
  onBackClick(isCurrentStatus?) {
    if (isCurrentStatus) {
      this.routeLink = this.MY_DOCUMENT_ROUTER_ON_BACK_LINK;
      this.router.navigate([this.routeLink], {
        queryParams: {
          page: this.page,
          pageSize: this.pageSize,
          enterprise: this.enterprise,
          documentType: this.documentTypeSearch,
          nameOrCode: this.nameOrCode,
          customerName: this.customerName,
          status: this.status,
          serviceType: this.serviceType,
          taxCode: this.taxCode,
          createdUser: this.createdUser,
          createdTimeFrom: this.createdTimeFrom,
          createdTimeTo: this.createdTimeTo,
          finishDateFrom: this.finishDateFrom,
          finishDateTo: this.finishDateTo,
          sortColumn: this.sortColumn,
          sortDirection: this.sortDirection
        }
      });
    } else {
      if (!this.routeLink || this.routeLink == '') {
        this.routeLink = this.MY_DOCUMENT_ROUTER_ON_BACK_LINK;
      }
      this.router.navigate([this.routeLink], {
        queryParams: {
          page: this.page,
          pageSize: this.pageSize,
          enterprise: this.enterprise,
          documentType: this.documentTypeSearch,
          nameOrCode: this.nameOrCode,
          customerName: this.customerName,
          status: this.status,
          serviceType: this.serviceType,
          taxCode: this.taxCode,
          createdUser: this.createdUser,
          createdTimeFrom: this.createdTimeFrom,
          createdTimeTo: this.createdTimeTo,
          finishDateFrom: this.finishDateFrom,
          finishDateTo: this.finishDateTo,
          sortColumn: this.sortColumn,
          sortDirection: this.sortDirection,
          receivedTimeFrom: this.receivedTimeFrom,
          receivedTimeTo: this.receivedTimeTo,
          signRole: this.signRole,
          nameOrEmailOrPhoneUserSign: this.nameOrEmailOrPhoneUserSign,
          senderName: this.senderName,
        }
      });
    }
  }

  getOffClose(data){
    const stopDropOld = [];
    if(data.userId == 'undefined'){
      this.stopDrop = false;
    }
    else{
      this.listSign.filter(ele => {
        if (!ele.role) {
          stopDropOld.push(ele)
        }
      });
if(stopDropOld.length >0){if(stopDropOld[0].userId == data.userId) {
  this.stopClose = false;
} else {
  this.stopClose = true;
}}
else {
  this.stopDrop = true;
}

  }
  }

  onSaveSignFlow() {
    this.listDataPopup // urer
    this.listSign //
    let message = '';
    const listUser = this.listDataPopup.filter(ele => ele.role == 2 && ele.CTS && ele.showImage );
    const listData = [];
    if(listUser.length > 0){
      this.listUserNoSign = listUser.filter(ele => ! this.listSign.some(ala => ala.userId === ele.userId));
    }
    else {
      this.listUserNoSign = [];
    }
    if(this.listUserNoSign.length > 0){
      message = this.message.getMessage('messages.confirm_TLLK');
      const confirmDialog = this.dialog.open(WarningComponent, {
        width: '700px',
        data: message
      });
      confirmDialog.afterClosed().subscribe(ref => {
        if (ref) {
          this.listSign.forEach(ele =>{
            if (!ele.role){
              // ele.name = b[0].name
              ele.role = '1'
            }
            if(!ele.x){
              ele.x = ele.positionX;
            }
            if(!ele.y){
              ele.y = ele.positionY;
            }
            if(!ele.width){
              ele.width = ele.widthRectangle;
            }
            if(!ele.height){
              ele.height = ele.heightRectangle;
            }
          })
          const b = this.getCheckShowImage(this.document);
          if(this.listUserNoSign.length >0){
            this.listUserNoSign.forEach(ele =>{
              this.listDataPopup.forEach(ala =>{
                if(ele.userId == ala.userId){
                  ala.showImage = false;
                }
              })
            })
          }
          this.listDataPopup.forEach(ele =>{
            ele.isSignDigitalCertificate = ele.CTS ? ele.CTS:false;
            if(ele.CTS){
              ele.signConfig = !b ? '{"showImage":false,"resize": false}':(ele.showImage?'{"showImage":true,"resize": false}':'{"showImage":false,"resize": false}')
            }
            else {
              if(ele.role !=1){
                ele.signConfig = '{"showImage":false,"resize": false}';
              }
              else {
                ele.signConfig = '';
              }
            }

          })
          const data = {
            ...[],
            id: this.document.id,
            userSign: this.listDataPopup,
            signPositions:this.listSign
          };
          this.contractService.updateUserSignReceive(data)
            .subscribe(result => {
              this.toastr.success(this.commonService.format(this.message.getMessage('messages.setup_signing_flow_receiver')));
              // this.isPanelDocumentViewSuccess.next({});
              window.location.reload();
            });
        }
      });
    }
    else {
      message = this.message.getMessage('messages.confirm_suscess');
      const confirmDialog = this.dialog.open(WarningComponent, {
        width: '350px',
        data: message
      });
      confirmDialog.afterClosed().subscribe(ref => {
        if (ref) {
          this.listSign.forEach(ele =>{
            if (!ele.role){
              // ele.name = b[0].name
              ele.role = '1'
            }
            if(!ele.x){
              ele.x = ele.positionX;
            }
            if(!ele.y){
              ele.y = ele.positionY;
            }
            if(!ele.width){
              ele.width = ele.widthRectangle;
            }
            if(!ele.height){
              ele.height = ele.heightRectangle;
            }
          })
          const b = this.getCheckShowImage(this.document);
          this.listDataPopup.forEach(ele =>{
            ele.isSignDigitalCertificate = ele.CTS ? ele.CTS:false;
            if(ele.CTS){
              ele.signConfig = !b ? '{"showImage":false,"resize": false}':(ele.showImage?'{"showImage":true,"resize": false}':'{"showImage":false,"resize": false}')
            }
            else {
              if(ele.role !=1){
                ele.signConfig = '{"showImage":false,"resize": false}';
              }
              else {
                ele.signConfig = '';
              }
            }

          })
          const data = {
            ...[],
            id: this.document.id,
            userSign: this.listDataPopup,
            signPositions:this.listSign
          };
          this.contractService.updateUserSignReceive(data)
            .subscribe(result => {
              this.toastr.success(this.commonService.format(this.message.getMessage('messages.setup_signing_flow_receiver')));
              // this.isPanelDocumentViewSuccess.next({});
              window.location.reload();
            });
        }
      });
    }


  }
  closeData(){
    let message = this.message.getMessage('messages.confirm_change_data');
    const confirmDialog = this.dialog.open(WarningComponent, {
      width: '350px',
      data: message
    });
    confirmDialog.afterClosed().subscribe(ref => {
      if (ref) {
        localStorage.removeItem('procedureIdActive');
        window.location.reload();
      }
    });
  }
  getCheckShowImage(data){
    if(data.signConfig){
    return JSON.parse(data.signConfig).showImage;}
    else {
      return false;
    }
  }
  openPopupSetUp() {
    this.loadSign = false;
    const b = this.getCheckShowImage(this.document);
    const dialogRef = this.dialog.open(SetupInternalSigningFlowComponent, {
      width: '70%',
      data: {
        procedureId: localStorage.getItem('procedureIdActive') ? localStorage.getItem('procedureIdActive') : 'no_use_sign_process',
        data:this.listDataPopup,
        checkShowImage:b
      }
    })
    dialogRef.afterClosed().subscribe(rs => {
      if (rs && rs != 1) {
        rs.forEach(ele =>{
          if(!ele.order){
            ele.order = 1;
          }
        })
        this.listDataPopupOld = JSON.parse(localStorage.getItem('dataOldPopup'));
        localStorage.removeItem('dataOldPopup');
        const b = rs.filter(item => {
          return   item.role === '1';
        });
        this.listDataPopup = rs;
        if(this.listDataPopup.length > 0){
          this.checkMan = true;
          // const dataDelete = this.dataPopup1 + this.dataPopup;
          if(this.listSign.length !=0 && this.listDataPopupOld && this.listDataPopupOld.length >0){
            this.dataPopup = this.listDataPopupOld.filter(ele => ! this.listDataPopup.some(ala => ala.userId === ele.userId));
            // this.dataPopup1 = this.listDataPopupOld.filter(ele => ! this.listDataPopup.some(ala => ele.role != 1 && (!ala.CTS||!ala.showImage)));
            this.dataPopup1 = this.listDataPopup.filter(ele => !ele.CTS || !ele.showImage);
            if(this.dataPopup.length >0 && this.dataPopup1.length == 0){
              this.dataPopup2  = this.dataPopup;
            }
            else if (this.dataPopup.length == 0 && this.dataPopup1.length > 0){
              this.dataPopup2 = this.dataPopup1;
            }
            else if(this.dataPopup.length > 0 && this.dataPopup1.length > 0) {
              this.dataPopup.forEach(element => {
                this.dataPopup2.push(element)
              })
              this.dataPopup1.forEach(element => {
                this.dataPopup2.push(element)
              })
            }
            else {this.dataPopup2 = [];}
            const data = this.listSign.filter(ele =>  this.dataPopup2.some(ala => ala.userId === ele.userId && ele.role ));
            if(data.length !=0){
              for (var i = 0;i<data.length;i++){
                // this.deleteSign(data[i].enterpriseId, data[i].userId, (data[i].contractSignId || data[i].idNumber))
                // enterpriseId: string, userId: string, signUuid
                const userId = data[i].userId;
                const enterpriseId = data[i].enterpriseId;
                const signUuid = data[i].contractSignId || data[i].idNumber;
                this.returnToPrevPosition();
                const files = this.createContractMohaService.fileUploadArray.getValue();
                let id = data[i].fileId;
                // if (files && files.length && files[i]) {
                //   const file = files[i] as any;
                //   id = file.id ? file.id : null;
                // }
                if (userId === undefined || userId === '' || userId === null || userId === 'undefined') {
                  // la khach hang ca nnhan
                  this.listSign = this.listSign.filter(sign => {
                    return (sign.enterpriseId !== enterpriseId && sign.customerId !== enterpriseId && sign.fileId === id) || sign.fileId !== id ||
                      ((sign.idNumber && signUuid != sign.idNumber) || (signUuid != sign.contractSignId && sign.contractSignId));
                  });
                } else {
                  this.listSign = this.listSign.filter(sign => {
                    return (sign.userId !== userId && sign.fileId === id) || sign.fileId !== id ||  ((sign.idNumber && signUuid != sign.idNumber) || (signUuid != sign.contractSignId && sign.contractSignId));
                  });
                }
                this.createContractMohaService.signPositions.next(this.listSign);
                const nodeOther = document.getElementById(`${signUuid}-sign-${enterpriseId}-approver-${userId}`);

                if (nodeOther) {
                  nodeOther.remove();
                }
                this.changeDataToTable()
              }
            }
            // this.createContractMohaService.signPositions.next(this.listSign);
          }
        }
        const listApro = rs.filter(item => {
          return  item.role === '2';
        });
        const listSign = rs.filter(item => {
          return  item.role === '1';
        });
        let maxOder = 0;
        if(listApro.length > 0){
          listApro.sort(function (a,b) {
            return a.order - b.order
          });
          var sortList = [];
          var count = 1;
          for (var i = 0;i < listApro.length;i++){
            if(i > 0 && listApro[i].order !== listApro[i-1].order){
              count++;
            }
            sortList.push(count)
            // sortList.push(Object.assign({},this.listOfDataUserSign[i]))
          }
          listApro.forEach((ele ,index) =>{
            sortList.forEach((ala,j) =>{
              if(index == j){
                ele.order = ala;
              }
            })
          })
           maxOder = listApro[0].order;
          listApro.forEach(ele =>{
            if(ele.order > maxOder){
              maxOder = ele.order;
            }
          })
        }

        listSign[0].order = maxOder +1;
        listApro.push(listSign[0]);
        this.listApproverSign = listApro.filter(item => {
          return  item.role === '2';
        })
        this.listDataSign.enterprise = listApro.filter(item => {
          return   item.role === '1';
        })
        this.listSign.forEach(ele =>{
          if (!ele.role || ele.role == '1'){
            ele.name = b[0].name
            ele.userId = b[0].userId
            ele.enterpriseId = b[0].enterpriseId
            // ele.role = '1'
          }
        })
        this.changeDataToTable();
        // this.listDataPopupOld = rs;
        this.loadSign = true;
        this.listDataPopup = listApro;
      }

      // else {
      //   this.listDataPopup = this.listDataPopupOld;
      // }
    });
  }

  subscribeValue() {
    this.notificationService.subscribeErrorService();

    this.subscriptions.add(this.createContractMohaService.pdfSrc.asObservable().subscribe(res => {
      // console.log(res)
      if (res) {
        this.pdfSrc = res;
        this.oldPdfSrc = res;
        if (this.createContractMohaService.isRenderNewFile && this.renderSignOnce == 0) {
          this.blockUI.start('');
          this.genSignatureData();
          // this.createContractMohaService.isRenderNewFile = false;
        }
      }
    })
    );

    this.subscriptions.add(
      this.createContractMohaService.document.asObservable().subscribe((res) => {
        if (res) {
          this.document = res;
          this.getListEnterpriseUserSignByDocumentId(this.document.id);
          // console.log('document', this.document);
          if(this.document.id) {
            if(res.mainContractAttachments && res.mainContractAttachments.length) {
              const isOrderNull = res.mainContractAttachments.every((file) => file.attachmentOrder == null);
              if(isOrderNull) {
                this.document.mainContractAttachments = [...this.document.mainContractAttachments.map((file, index) => ({
                  ...file,
                  attachmentOrder: index
                }))];
              } else {
                const mainContractAttachmentsnewSort = this.document.mainContractAttachments.sort((a, b) => {
                  return a.attachmentOrder - b.attachmentOrder;
                });
                this.document.mainContractAttachments = [...mainContractAttachmentsnewSort];
              }
            }
          } else {
            setTimeout(() => {
              if(res.mainContractAttachments && res.mainContractAttachments.length) {
                const isOrderNull = res.mainContractAttachments.every((file) => file.attachmentOrder == null);
                if(isOrderNull) {
                  this.document.mainContractAttachments = [...this.document.mainContractAttachments.map((file, index) => ({
                    ...file,
                    attachmentOrder: index
                  }))];
                } else {
                  const mainContractAttachmentsnewSort2 = this.document.mainContractAttachments.sort((a, b) => {
                    return a.attachmentOrder - b.attachmentOrder;
                  })
                  this.document.mainContractAttachments = [...mainContractAttachmentsnewSort2];
                }
              }
            }, 0);
          }
          this.createContractMohaService.contractCodePositions.subscribe(ref => {
            if (ref) {
              this.listSignature = ref.map((item, idx) => {
                return { id: `contract-code-config-${idx}`, page: item.pageIndex, ...item };
              });
              if (res.mainContractAttachments && res.mainContractAttachments.length) {
                this.listSignatureTable = ref.map((item, idx) => {
                  const fileDoc = res.mainContractAttachments.find(
                    file => file.id ? file.id === item['fileId'] : file.fileName === decodeURI(item['fileId']));
                  if (fileDoc) {
                    this.addListSignHeadRows(fileDoc['fileName']);
                  }
                  return {
                    id: item.id ? item.id : `contract-code-config-${idx}`,//set id vao listTable
                    fileName: fileDoc && fileDoc['id'] ? fileDoc['fileName'] : '',
                    fontFamily: item.fontFamily ? item.fontFamily : 'Times-Roman',
                    fileId: item.fileId,
                    fontSize: item.fontSize,
                    fontStyle: item.fontStyle,
                    page: item.pageIndex
                  }
                });
              }
            }
          })
          if (!res.mainContractAttachments) {
            this.createContractMohaService.contractCodePositions.subscribe(rs => {
              if (!this.listSignatureTable.length) {
                this.listSignatureTable = rs;
                this.listSignatureTable.forEach(item => {
                  this.addListSignHeadRows(item.fileName ? item.fileName : this.getDecodeUri(item.fileId));
                })
              }
            })
          }
          if (
            this.document.filePath &&
            !this.createContractMohaService.selectedTemplate.getValue() &&
            !this.createContractMohaService.pdfSrc.getValue()
          ) {
            this.viewDocumentLink(this.document.mainContractAttachments)
            this.viewDocumentUploadFileUpload(this.document.id, this.document.mainContractAttachments);
          } else if (this.createContractMohaService.selectedTemplate.getValue) {
            if (this.document.mainContractAttachments && this.document.mainContractAttachments.length) {
              this.document.filePath = this.document.mainContractAttachments.find(item => !item.source || item.source == 'FORM').path;
              this.viewDocumentLink(this.document.mainContractAttachments)
              this.viewDocumentUploadFileUpload(this.document.id, this.document.mainContractAttachments);
            }
          };
        }
      })
    );
    this.subscriptions.add(
      this.createContractMohaService.isOnAutoNumber.asObservable().subscribe((res) => {
        if (res) {
          this.isOnAutoNumber = res;
          this.generalFormInfoMohaComponent.isOnAutoNumber = true;
          this.currentTab = 0;
        }
      })
    );
    this.subscriptions.add(
      this.createContractMohaService.configAutoNumber.asObservable().subscribe((res) => {
        if (res) {
          this.configAutoNumber = res;
        }
      })
    );
    this.subscriptions.add(
      this.createContractMohaService.refreshContractCode.asObservable().subscribe((res) => {
        if (res) {
          this.refreshContractCode = res;
        } else {
          this.refreshContractCode = false;
        }
      })
    );

    this.subscriptions.add(
      this.commonService.getCurrentLanguage().subscribe((lang) => {
        if (lang !== this.language) {
          location.reload();
        }
      })
    );

    this.subscriptions.add(this.createContractMohaService.isShowPopupPdf.subscribe(ref => {
      this.isHide = ref;
    }));
    this.subscriptions.add(this.createContractMohaService.createContractType.subscribe(ref => {
      this.createContractType = ref;
    }))

    this.subscriptions.add(
      this.createContractMohaService.recordsPartySign.subscribe(ref => {
        this.isHaveUserSign = !!ref;
        if (this.createContractType === 0) {
          this.renderSignViewWhenDataChange();
        }
        else {
          const dataCustomer = ref.filter(item => {
            return !item.isCreatedSide
          })
          this.listDataSign.customer = dataCustomer;
          this.listSign.forEach(sign => {
            if (!sign.name && sign.enterpriseId) {
              const enterprise = this.listDataSign.customer.find(item => item.enterpriseId === sign.enterpriseId && item.userId === sign.userId);
              if (enterprise) {
                Object.keys(enterprise).forEach(key => {
                  sign[key] = enterprise[key];
                });
              }
            }
          })
        }
      })
    );
    this.subscriptions.add(
      this.createContractMohaService.recordsUserPerformSign.subscribe(ref => {
        if (this.createContractType === 0) {
          this.listDataSign.enterprise = ref.filter(item => {
            const createSide = this.createContractMohaService.recordsPartySign.getValue().find(item => item.isCreatedSide);
            item.enterpriseId = createSide && createSide.enterpriseId ? createSide.enterpriseId : null;
            return item.role === '1';
          })
          this.listApproverSign = ref.filter(item => {
            return item.role === '2' && item.isSignDigitalCertificate && item.signConfig.showImage;
          })
          this.listSign.forEach(sign => {
            if (!sign.name && sign.enterpriseId) {
              const approver = this.listApproverSign.find(item => item.enterpriseId === sign.enterpriseId && item.userId === sign.userId);
              if (approver) {
                Object.keys(approver).forEach(key => {
                  sign[key] = approver[key];
                });
              }
              const enterprise = this.listDataSign.enterprise.find(item => item.enterpriseId === sign.enterpriseId && item.userId === sign.userId);
              if (enterprise) {
                Object.keys(enterprise).forEach(key => {
                  sign[key] = enterprise[key];
                });
              }
            }
          })
          this.renderSignViewWhenDataChange();
          this.footNote.showSignatureFromData();
        } else {
          this.listDataSign.enterprise = ref.filter(item => {
            const createSide = this.createContractMohaService.recordsPartySign.getValue().find(item => item.isCreatedSide);
            item.enterpriseId = createSide && createSide.enterpriseId ? createSide.enterpriseId : null;
            return item.role === '1';
          })
          this.listApproverSign = ref.filter(item => {
            return item.role === '2' && item.isSignDigitalCertificate && item.signConfig.showImage;
          })
          this.listSign.forEach(sign => {
            if (!sign.name && sign.enterpriseId) {
              const approver = this.listApproverSign.find(item => item.enterpriseId === sign.enterpriseId && item.userId === sign.userId);
              if (approver) {
                Object.keys(approver).forEach(key => {
                  sign[key] = approver[key];
                });
              }
              const enterprise = this.listDataSign.enterprise.find(item => item.enterpriseId === sign.enterpriseId && item.userId === sign.userId);
              if (enterprise) {
                Object.keys(enterprise).forEach(key => {
                  sign[key] = enterprise[key];
                });
              }
            }
          })
        }
      })
    );
    this.subscriptions.add(
      this.createContractMohaService.signPositions.subscribe(ref => {
        if (ref) {
          this.listSign = ref;
        }
      })
    );

    this.subscriptions.add(
      this.createContractMohaService.isSignatureConfiguration.subscribe(ref => {
        if (ref === false) {
          this.currentTab = 1;
          this.createContractMohaService.isSignatureConfiguration.next(null);
        }
      })
    )
    this.subscriptions.add(
      this.createContractMohaService.isDuplicateCode.subscribe(ref => {
        if (ref) {
          this.createContractMohaService.codeIsDuplicate.next(true);
          this.currentTab = 0;
        }
        if (ref && this.createContractMohaService.currentStep.getValue() === 3) { //cuongnm fix step 2 -> 3
          this.tabMode = 'info';
          this.createContractMohaService.isInvalidInfo.next(false);
        }
      })
    );
    this.subscriptions.add(
      this.createContractMohaService.isInvalidInfo.subscribe(ref => {
        if (ref) {
          this.currentTab = 0;
        }
        if (ref && this.createContractMohaService.currentStep.getValue() === 3) { //cuongnm fix step 2 -> 3
          this.tabMode = 'info';
          this.createContractMohaService.isInvalidInfo.next(false);
        }
      })
    );

    this.subscriptions.add(this.createContractMohaService.signatureData.subscribe(ref => {
      if (ref) {
        this.signaturesFormPositions = ref;
        this.renderSignViewWhenDataChange();
      }
    }));

    this.subscriptions.add(this.createContractMohaService.mainContractAttactment.subscribe(ref => {
      if (ref && ref.length) {
        this.document.mainContractAttachments = []
        ref.forEach((file, indexMainContractAttachment) => {
          this.document.mainContractAttachments.push({
            ...file,
            id: file.id ? file.id : '',
            fileSize: file.file && file.file.size ? file.file.size : file.fileSize,
            fileName: file.file && file.file.name ? file.file.name : file.fileName,
            path: file.path,
            active: true,
            src: file.src
          });
          if(this.document.id) {
            this.createContractMohaService.fileUploadSrc.getValue().forEach((src, indexFileUploadSrc) => {
              if(indexMainContractAttachment === indexFileUploadSrc) {
                this.listPdfSrc[file.path] = src;
              }
            })
          } else {
            if (file.src) {
              this.listPdfSrc[file.path] = file.src;
            }
          }
        })
      }
    }));
    this.subscriptions.add(this.createContractMohaService.fileUploadArray.subscribe(ref => {
      if (ref) {
        this.fileUploads = ref;
        if (!ref.length) {
          // this.document.filePath = null;
          this.createContractMohaService.document.next(this.document);
        }
        setTimeout(() => {
          const tabs = document.getElementsByClassName('tab');
          if (tabs) {
            Array.from({ length: tabs.length }, (v, i) => i).forEach(index => {
              const tab = tabs.item(index) as HTMLElement;
              tab.style.width = 100 / this.fileUploads.length + '%';
            })
          }
        }, 100);
      }
    }))
    this.subscriptions.add(
      this.createContractMohaService.maxSizeSystem.subscribe((res) => {
        if (res) {
          this.maxSizeSystem = res;
        } else {
          this.maxSizeSystem = 0;
        }
      })
    );
    this.subscriptions.add(
      this.createContractMohaService.biggerThan10MBFileSize.subscribe((res) => {
        if (res) {
          this.biggerThan10MBFileSize = res;
        }
      })
    );
  }


  addEventsCheckFormChange() {
    // Check form change real-time when press printable key
    document
      .getElementById("pdfContainer")
      .addEventListener("keydown", (event) => {
        const keycode = event.keyCode;
        const isPrintableKey =
          (keycode > 47 && keycode < 58) || // number keys
          keycode === 8 ||
          keycode === 46 || // remove keys
          (keycode > 64 && keycode < 91) || // letter keys
          (keycode > 95 && keycode < 112) || // numpad keys
          (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
          (keycode > 218 && keycode < 223) || // [\]' (in order)
          keycode === 32; // space break
        if (isPrintableKey) {
          this.isFormChanging = true;
        }
      });

    // Check form change in document content
    document.getElementById("pdfContainer").addEventListener("change", (_) => {
      this.isFormChanging = true;
    });
  }

  async viewDocumentLink(files) {
    if (files && files.length) {
      const firstFile = files[0];
      this.pdfSrc = await this.viewDocumentUpload(firstFile);
      // this.viewDocumentsUpload(this.document.id);
      // load các file còn lại
      let fileUpload = []
      firstFile['size'] = firstFile.fileSize
      fileUpload.push(firstFile)

      this.document.mainContractAttachments.forEach(file => {
        if (file.path != firstFile.path) {
          file['size'] = file.fileSize
          this.viewDocumentUpload(file);
          fileUpload.push(file)
        }
      });

      if (fileUpload.length > 0) {
        this.createContractMohaService.fileUploadArray.next(fileUpload);
        this.createContractMohaService.mainContractAttactment.next(fileUpload);
      }
    }
  }

  /**
   * every things ok now.
   */
  ngAfterViewInit() {
    // ẩn nút toggle từ menu trái
    document.getElementById("sidebarToggle").style.display = "none";
  }

  /**
   * Destroy the component.
   */
  ngOnDestroy() {
    if (this.EventWarningContractSubscription) {
      this.EventWarningContractSubscription.unsubscribe();
    }
    this.apiService.removeUrlToHandlingErrorRestApis();
    this.notificationService.unsubscribeErrorService();
    this.subscriptions.unsubscribe();
    // this.panelSuccessSubscription.unsubscribe();
    // this.panelDocumentComponent.formChangesSubscription.unsubscribe();
    // this.panelDocumentComponent.onChangePanelData.unsubscribe();
    // this.onChangeTemplateSubscription.unsubscribe();

    document.removeEventListener('mouseup', () => { });
    localStorage.removeItem('procedureIdActive');
  }

  /**
   * Submit create document
   */

  /**
   *  Back to page search
   */

  /**
   * Set route when back navigate
   */
  backNavigate(searchParams) {
    this._location.back();
  }

  /**
   * Get document by id.
   * @param id the document id.
   */

  getListEnterpriseUserSignByDocumentId(id) {
    localStorage.removeItem('typeAllowCheck');
    localStorage.removeItem('enterprisePhoneProcessing');
    localStorage.removeItem('enterpriseNameProcessing');
    this.documentService.getListEnterpriseUserSignBydocumentIdService(id).subscribe(rs => {
      if (rs.data) {
        rs.data.enterpriseSign.map(enter => {
          // trạng thái đang xử lý status = 2
          if (enter.status === 2) {
            localStorage.setItem('typeAllowCheck', enter.type);
            localStorage.setItem('enterprisePhoneProcessing', enter.enterprisePhone);
            localStorage.setItem('enterpriseNameProcessing', enter.enterpriseName);
          }
        });
        const {enterpriseSign, userSign, initial, enterpriseSignIdInFlow, userApproves,isSetUpSignFlow, userSignAll} = rs.data;
        // this.enterpriseSign = enterpriseSign;
        // this.userSign = userSign;
        // this.userApproves = userApproves;

        // xử lý tên cho chân ký
        if (this.listSign.length) {
          this.listSign.forEach((sign: any) => {
            const customer = enterpriseSign.find(es => es.enterpriseId === sign.enterpriseId && !es.isCreatedSide);
            const signer = userSign.find(res => res.userId === sign.userId && res.enterpriseSignId === sign.enterpriseId && res.role === 1);
            const approver = userSign.find(res => res.userId === sign.userId && res.enterpriseSignId === sign.enterpriseId && res.role === 2);
            if (signer && signer.isCreatedSide) {
              sign.name = signer ? signer.userName : null;
            } else if (approver && approver.isSignDigitalCertificate) {
              sign.name = approver ? approver.userName : null;
            } else if (customer) {
              sign.name = customer ? customer.enterpriseName : null;
            }
          });
        }
        if(enterpriseSign) {
          let arrayEnterpriseCreateContract;
          let arrayUserCreateContract;
          arrayEnterpriseCreateContract = enterpriseSign.filter((data) => data.enterpriseId == this.enterpriseId && data.isCreatedSide == true);
          arrayUserCreateContract = userSign.filter((data) => data.userId == this.userLoginId && data.isCreatedSide == true);
          if(arrayEnterpriseCreateContract.length || arrayUserCreateContract.length) {
            this.checkUSerCreateContract = true;
          } else {
            this.checkUSerCreateContract = false;
          }
        }
        let check ;
         check = localStorage.getItem("enterpriseId");
         if(!check){
           check = localStorage.getItem("customerId");
         }
         const isSignFlow = enterpriseSign.some(x => x.enterpriseId == check && x.isSetUpSignFlow == true)
        this.isSetUpSignFlow = isSignFlow
        if (this.panelDocumentViewComponent) {
          this.dataCheckStatus(this.document,enterpriseSign,userSign)
          // const currentEnterpriseProcess = enterpriseSign.filter(item => item.enterpriseId === this.enterpriseId
          //     && (item.status === this.enumContractEnterpriseStatus.PROCESSING || item.status === this.enumContractEnterpriseStatus.WAIT_SETUP_FLOW));
          this.panelDocumentViewComponent.getDocumentById(this.document, null, this.serviceTypeEntity, enterpriseSign, userSign, userApproves, initial, enterpriseSignIdInFlow,isSetUpSignFlow, userSignAll, [], []);
          // this.isSetSignFlow = (userSign.length === 0 && currentEnterpriseProcess.length > 0 && document.status == this.enumContractStatus.PROCESSING);
        }
      }
    }, (error) => console.log(error));
  }

  dataCheckStatus(document,enterpriseSign,userSign){
    const currentEnterpriseProcess = enterpriseSign.filter(item => item.enterpriseId === this.enterpriseId
        && (item.status === this.enumContractEnterpriseStatus.PROCESSING || item.status === this.enumContractEnterpriseStatus.WAIT_SETUP_FLOW));
    this.isSetSignFlow = (userSign.length === 0 && currentEnterpriseProcess.length > 0 && document.status == this.enumContractStatus.PROCESSING);
  }

  viewDocumentUploadFileUpload(id: string, mainContractAttachments: any[]) {
    return this.commonService.getViewPdfsForDocument(id).subscribe(async (res) => {
      // console.log(res.data);
      // console.log(this.document.mainContractAttachments);
      if (!res.data) {
        return;
      }
      const newData = [];
      this.document.mainContractAttachments.forEach((mainContractAttachment) => {
        res.data.forEach((data) => {
          if(mainContractAttachment.id === data.fileId) {
            newData.push(data);
          }
        })
      });
      res.data = [...newData];
      // console.log(res.data);
      const fileUpload = [];
      const fileSrc = [];
      for await (const [index, item] of res.data.entries()) {
        const attachment = mainContractAttachments.find(att => item.fileId === att.id);
        const file = new File([new Uint8Array(item.bytes)], attachment ? attachment.fileName : `file_${index}.pdf`, { type: 'application/pdf' }) as any;
        file.id = item.fileId;
        fileUpload.push(file);
        const base64 = await this.checkContentTypeThenAddFile(file);
        fileSrc.push(base64);
      }
      if (fileUpload.length > 0) {
        this.createContractMohaService.fileUploadArray.next(fileUpload);
        this.createContractMohaService.fileUploadSrc.next(fileSrc);
        this.createContractMohaService.pdfSrc.next(fileSrc[0]);
      }
    });
  }

  async viewDocumentUpload(file) {
    const data: ViewDocumentReferenceDto = {
      pdfFilePath: file.path,
      mainContractId: this.document.id,
      referenceContractId: "",
    };
    const queryString = Object.entries(data)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
    // const res = await this.commonService.getViewPdfForDocumentByFilePath(data).toPromise();
    let pdfSrc;
    if (!file.src) {
      if (!this.env.pdfViewFullDownload && file.fileSize && file.fileSize > 10485760) {
        pdfSrc = `${this.BASE_URL}?${queryString}`;
        this.listPdfSrc[file.path] = pdfSrc;
      } else {
        const res = await this.commonService.getViewPdfForDocumentByFilePath(data).toPromise();
        pdfSrc = await this.showPdf(res, file.path);
      }
    }
    return pdfSrc;
  }

  /**
   * Process for uploading file case.
   * @param data the document data with with file path upload success.
   */

  /**
   * Process upload Attachment when has attach file from local
   * @param data Obj document
   */
  processUploadAttachment(data) {
    this.panelDocumentComponent.uploadFile(
      (attachments) => {
        data.newUploadContractAttachments = attachments;
        this.updateDocumentByUploadFileToServer(data);
      },
      () => {
        this.updateDocumentByUploadFileToServer(data);
      }
    );
  }

  /**
   * Update document to server.
   * @param data json data update to server.
   */
  private updateDocumentByUploadFileToServer(data) {
    const assignData: any = data;
    this.document = assignData;

    let navigatorParam = {};

    // get navigator params.
    if (this.pageSize > 0) {
      navigatorParam = {
        page: this.page,
        pageSize: this.pageSize,
        currentPage: this.currentPage,
        enterprise: this.enterpriseSearch,
        documentType: this.documentTypeSearch,
        nameOrCode: this.nameOrCode,
        customerName: this.customerName,
        status: this.status,
        serviceType: this.serviceType,
        taxCode: this.taxCode,
        createdUser: this.createdUser,
        createdTimeFrom: this.createdTimeFrom,
        createdTimeTo: this.createdTimeTo,
        finishDateFrom: this.finishDateFrom,
        finishDateTo: this.finishDateTo,
        sortColumn: this.sortColumn,
        sortDirection: this.sortDirection,
      };
    }

    // if (this.flagCopy) {
    //   this.document.id = null;
    //   this.document.finishDate = null;
    // }

    if (this.flagCopy || !this.document.id) {
      // create.
      // Get customer contacter's email and phone
      this.document.email = this.panelDocumentComponent.customer.customerEmail;
      this.document.phone = this.panelDocumentComponent.customer.customerPhone;

      this.documentService
        .addDocument(
          this.document,
          this.documentCodeDuplicateHanlder.bind(this)
        )
        .subscribe((rs) => {
          if (rs && rs.success) {
            const updateNameSie = {
              fileName: this.document.fileNameUpdate,
              fileSize: this.document.fileSizeUpdate,
              contractId: rs.data,
            };
            // this.documentService.updateFileNameAndFileSize(updateNameSie).subscribe();
            this.show = false;
            // Show success message.
            this.toastr.success(
              this.message.getMessage("messages.add_success")
            );

            // navigate to list screen.
            this.router.navigate(
              ["/home-enterprise/search-my-created-document/"],
              {
                // queryParams: navigatorParam
                queryParams: {},
              }
            );
          } else if (rs.code == ErrorCode.MaxSizeError) {
            this.maxSize = rs.data > 0 ? rs.data : 10 * 1024 * 1024;
          }
        });
    } else {
      // update.
      // Get customer contacter's email and phone
      this.document.email = this.panelDocumentComponent.customer.customerEmail;
      this.document.phone = this.panelDocumentComponent.customer.customerPhone;
      this.documentService.updateDocumentUpdload(
        this.document,
        () => {
          this.show = false;
          // Show success message.
          this.toastr.success(
            this.message.getMessage("messages.update_success")
          );

          // navigate to list screen.
          this.router.navigate(
            ["/home-enterprise/search-my-created-document/"],
            {
              queryParams: navigatorParam,
            }
          );
        },
        () => {
          // reload screen if deprecate version.
          // this.getDocumentById(this.document.id);
        },
        this.documentCodeDuplicateHanlder.bind(this)
      );
    }
  }

  /**
   * Check code document duplicate
   * @param rs data after request api
   */
  private documentCodeDuplicateHanlder(rs: any) {
    if (!rs.success) {
      if (String(rs.code) === "0x001703") {
        this.panelDocumentComponent.documentCodeDuplicateHanlder(rs);
      } else {
        this.notificationService.notify(
          Utils.toErrorMessage(
            rs,
            this.message.getMessage("messages.error_message")
          )
        );
      }
    }
  }

  private initFormData() {
    // Get current date
    const today = new Date();
    const dd = today.getDate();
    const mm = today.getMonth() + 1; // January is 0!
    const yyyy = today.getFullYear();
    let currentDay = dd.toString();
    let currentMonth = mm.toString();

    // Add zero if day or month < 10
    if (dd < 10) {
      currentDay = "0" + dd;
    }

    if (mm < 10) {
      currentMonth = "0" + mm;
    }

    this.defaultDocumentData = {
      currentDay,
      currentMonth,
      currentYear: yyyy.toString(),
      currentShortYear: yyyy.toString().slice(2, 4),
      currentDate: currentDay + "/" + currentMonth + "/" + yyyy.toString(),
    };
    this.getListEnterpriseUserSignByDocumentId(this.idDocument);
  }

  /**
   * Confirm before navigation
   */
  /**
   * Load addresses
   */
  private loadAddresses() {
    /**
     * Get cities list from local storage
     */
    this.cities = JSON.parse(localStorage.getItem("cities"));
    /**
     * Get districts list from local storage
     */
    this.districts = JSON.parse(localStorage.getItem("districts"));
    /**
     * Get wards list from local storage
     */
    this.wards = JSON.parse(localStorage.getItem("wards"));
  }

  /**
   * Get data and bind to document template
   * @param data: any
   */


  public blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    // A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return theBlob as File;
  };

  async showPdf(blob: any, pdfFilePath: string) {
    const file = this.blobToFile(blob, 'application/pdf');
    const pdfSrc = await this.commonService.readFileAsync(file);
    this.listPdfSrc[pdfFilePath] = pdfSrc;
    return pdfSrc;
  }

  /**
   * Selected document form
   */

  /**
   *  Refresh input upload file
   */
  private reset() {
    this.inputUploadFile.nativeElement.value = "";
  }

  /**
   * Reset input when selected type document
   */


  onClickSetColor(value: string) {
    this.isShowMatRaised = value;
  }

  handleBack() { }

  public async getFile(e) {
    this.blockUI.start();
    if (typeof FileReader !== "undefined") {
      const files = e.target.files;
      let size = 0;
      const filesUpload = this.createContractMohaService.fileUploadArray.getValue() ? this.createContractMohaService.fileUploadArray.getValue() : [];
      const filesSrc = this.createContractMohaService.fileUploadSrc.getValue() ? this.createContractMohaService.fileUploadSrc.getValue() : [];
      filesUpload.forEach(item => {
        size += item.size
      });
      const allFile = filesUpload.map(item => {
        return { name: item.name };
      });

      const fileSave = [];
      const fileSrc = [];
      const fileAttach = [];
      const limitSize = this.maxSize; // 10MB
      let error: 'type' | 'size' = null;
      for (let file of files) {
        if (file.type !== 'application/pdf') {
          error = 'type';
          break;
        } else {
          // if (file.size <= limitSize) {
            size += file.size;
            const src = await this.checkContentTypeThenAddFile(file);
            if (src) {
              const nameFileSplit = file.name.substring(0, file.name.length - 4);
              const find = allFile.find(item => {
                return item.name === file.name;
              });
              const specials = [
                '/', '.', '*', '+', '?', '|',
                '(', ')', '[', ']', '{', '}', '\\'
              ];
              const regSpe = new RegExp('(\\' + specials.join('|\\') + ')', 'gim');
              const nameFileReg = nameFileSplit.replace(regSpe, '\\$1');
              const sameName = allFile.filter(item => {
                return new RegExp(nameFileReg + '\\([0-9]{1,}\\)\.' + 'pdf').test(item.name);
              });
              const number = sameName.map(item => {
                const listNumber = item.name.match(/\([0-9]{1,}\)/g);
                return listNumber.length ? listNumber[listNumber.length - 1].replace('(', '').replace(')', '') : null;
              });
              if (find && !number.length) {
                file = new File([file], `${nameFileSplit}(1).pdf`, { type: file.type });
              } else if (find && number.length) {
                const numbers = Array.from({ length: 100 }, (v, i) => i + 1);
                let index;
                for (const iterator of numbers) {
                  if (!number.includes(iterator.toString())) {
                    index = iterator;
                    break;
                  }
                }
                file = new File([file], `${nameFileSplit}(${index}).pdf`, { type: file.type });
              }
              file.id = encodeURIComponent(file.name);
              fileSave.push(file);
              fileSrc.push(src);
              allFile.push(file);
              const path = +new Date() + ""
              fileAttach.push({
                file: file,
                src: src,
                path: path
              })

            } else {
              error = 'type';
              break;
            }
          this.fileUploadSize = size;
        }
      }
      if (error) {
        switch (error) {
          case 'type':
            if (!this.toastr.findDuplicate(this.message.getMessage('messages.only_accept_pdf'), true, true)) {
              this.toastr.error(this.message.getMessage('messages.only_accept_pdf'));
              this.blockUI.stop();
            }
            break;
          default: break;
        }
      }
      else if (fileSave.length) {
        if (this.fileUploadSize <= this.size10MB) {
          const newFileArray = filesUpload.concat(fileSave);
          const newFileSrc = filesSrc.concat(fileSrc);
          if (this.createContractMohaService.createContractType.getValue() === FormActionType) {
            this.createContractMohaService.signPositions.next([]);
            this.createContractMohaService.contractCodePositions.next([]);
            this.createContractMohaService.listSignatureTable.next([]);
          }
          this.createContractMohaService.fieldData = null;
          this.createContractMohaService.fileExport = null;
          this.createContractMohaService.tableModel = null;
          this.createContractMohaService.signatureData.next(null);
          this.createContractMohaService.documentFileTemplate.next(null);
          this.createContractMohaService.changeFileOutput = true;
          this.createContractMohaService.fileUploadArray.next(newFileArray);
          this.createContractMohaService.fileUploadSrc.next(newFileSrc);
          if (!this.document.mainContractAttachments) {
            this.document.mainContractAttachments = [];
          }
          fileAttach.forEach(file => {
            this.document.mainContractAttachments.push({
              attachmentOrder: this.document.mainContractAttachments.length,
              id: '',
              fileSize: file.file.size,
              fileName: file.file.name,
              path: file.path,
              active: true,
              src: file.src
            })
            this.listPdfSrc[file.path] = file.src
          });
          this.createContractMohaService.mainContractAttactment.next(this.document.mainContractAttachments);
          this.createContractMohaService.createContractType.next(FileUploadType);
          if (!filesUpload.length) {
            this.createContractMohaService.pdfSrc.next(newFileArray[0]);
          }

          if (!this.listDataSign.customer.length && !this.listDataSign.enterprise.length) {
            this.listDataSign.customer = this.createContractMohaService.recordsPartySign.getValue().filter(item => {
              return !item.isCreatedSide
            });
            this.listDataSign.enterprise = this.createContractMohaService.recordsUserPerformSign.getValue().filter(item => {
              const createSide = this.createContractMohaService.recordsPartySign.getValue().find(item => item.isCreatedSide);
              item.enterpriseId = createSide && createSide.enterpriseId ? createSide.enterpriseId : null;
              return item.role === '1';
            });
            this.listApproverSign = this.createContractMohaService.recordsUserPerformSign.getValue().filter(item => {
              return item.role === '2' && item.isSignDigitalCertificate && item.signConfig.showImage;
            });
          }
        } else if (this.fileUploadSize > this.size10MB && this.fileUploadSize <= this.maxSizeSystem) {
          const residualCapacity = this.fileUploadSize - this.size10MB;
          if (!this.biggerThan10MBFileSize) {
            this.toastr.error(this.message.getMessage('messages.uploaded_files_exceed'));
            this.blockUI.stop();
            return;
          } else {
            if (this.biggerThan10MBFileSize >= residualCapacity) {
              const newFileArray = filesUpload.concat(fileSave);
              const newFileSrc = filesSrc.concat(fileSrc);
              if (this.createContractMohaService.createContractType.getValue() === FormActionType) {
                this.createContractMohaService.signPositions.next([]);
                this.createContractMohaService.contractCodePositions.next([]);
                this.createContractMohaService.listSignatureTable.next([]);
              }
              this.createContractMohaService.fieldData = null;
              this.createContractMohaService.fileExport = null;
              this.createContractMohaService.tableModel = null;
              this.createContractMohaService.signatureData.next(null);
              this.createContractMohaService.documentFileTemplate.next(null);
              this.createContractMohaService.changeFileOutput = true;
              this.createContractMohaService.fileUploadArray.next(newFileArray);
              this.createContractMohaService.fileUploadSrc.next(newFileSrc);
              if (!this.document.mainContractAttachments) {
                this.document.mainContractAttachments = [];
              }
              fileAttach.forEach(file => {
                this.document.mainContractAttachments.push({
                  attachmentOrder: this.document.mainContractAttachments.length,
                  id: '',
                  fileSize: file.file.size,
                  fileName: file.file.name,
                  path: file.path,
                  active: true,
                  src: file.src
                })
                this.listPdfSrc[file.path] = file.src
              });
              this.createContractMohaService.mainContractAttactment.next(this.document.mainContractAttachments);
              this.createContractMohaService.createContractType.next(FileUploadType);
              if (!filesUpload.length) {
                this.createContractMohaService.pdfSrc.next(newFileArray[0]);
              }

              if (!this.listDataSign.customer.length && !this.listDataSign.enterprise.length) {
                this.listDataSign.customer = this.createContractMohaService.recordsPartySign.getValue().filter(item => {
                  return !item.isCreatedSide
                });
                this.listDataSign.enterprise = this.createContractMohaService.recordsUserPerformSign.getValue().filter(item => {
                  const createSide = this.createContractMohaService.recordsPartySign.getValue().find(item => item.isCreatedSide);
                  item.enterpriseId = createSide && createSide.enterpriseId ? createSide.enterpriseId : null;
                  return item.role === '1';
                });
                this.listApproverSign = this.createContractMohaService.recordsUserPerformSign.getValue().filter(item => {
                  return item.role === '2' && item.isSignDigitalCertificate && item.signConfig.showImage;
                });
              }
            } else {
              this.toastr.error(this.message.getMessage('messages.account_Subscribe_File_Download_Capacity_resource'));
              this.blockUI.stop();
              return;
            }
          }
        } else {
          this.toastr.error(this.message.getMessage('validation.file_config').replace('{0}', String(Math.floor(this.maxSizeSystem/1024/1024))));
          this.blockUI.stop();
          return;
        }
      }
    }
    this.blockUI.stop();
    this.changeDataToTable()
    return true;
  }

  private async checkContentTypeThenAddFile(file: File): Promise<boolean> {
    const ct = await FileUtils.getContentType(file);
    let r = null;
    if (ContentType.PDF === ct) {
      r = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        // tslint:disable-next-line:no-shadowed-variable
        reader.onload = (e: any) => {
          resolve(e.target.result);
        };
        reader.readAsArrayBuffer(file);
      })
    }
    return new Promise((resolve, reject) => resolve(r));
  }

  private checkHaveDataForm(fields: Field[]): boolean {
    const fieldsHaveValue = fields.filter((field) => {
      return field.value;
    });
    return fieldsHaveValue.length ? true : false;
  }

  // process sign
  textLayerRendered(e) {
    const element = e.source.textLayerDiv;
    const pageIndex = e.source.pageNumber
    // lấy các chữ ở trang pageNumber
    let signPosition;
    let signaturePosition;
    if ((this.listSign && this.listSign.length > 0) || (this.listSignature && this.listSignature.length > 0)) {
      const files = this.createContractMohaService.fileUploadArray.getValue();
      let id;
      if (files && files.length && files[this.activeFile]) {
        const file = files[this.activeFile] as any;
        id = file.id ? file.id : null;
      }
      if (this.listSign && this.listSign.length > 0) {
        signPosition = this.listSign.filter((item) => {
          return item.pageIndex === pageIndex && item.fileId === id && !(item.id && item.id.includes('contract-code-config-'));
        });
      }
      if (this.listSignature && this.listSignature.length > 0) {
        signaturePosition = this.listSignature.filter((item) => {
          return item.pageIndex === pageIndex && item.fileId === id && (item.id && item.id.includes('contract-code-config-'));
        });
      }
    }

    if (signPosition && signPosition.length > 0) {

      for (const position of signPosition) {

        const x = position.positionX;
        const y = position.positionY;
        const _width = position.widthRectangle;
        const _height = position.heightRectangle;
        const name = position.name;
        const id = position.enterpriseId || position.customerId;
        const userId = position.userId;
        const elWidth = element.offsetWidth;
        const elHeight = element.offsetHeight;
        const htmlNode = this.getStampWrapper(x, y, _width, _height, name, id, elWidth, elHeight, userId, null, null, [], false, (position.contractSignId || position.idNumber), position.row_number);
        element.appendChild(htmlNode);
        if (position.enterpriseId) {
          if (position.enterpriseId === this.signNeedShow && position.userId === this.signApproverNeedShow) {
            const node = document.getElementById(`${position.contractSignId}-sign-${this.signNeedShow}-approver-${this.signApproverNeedShow}`);
            node.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
          }
          this.signNeedShow = null;
          this.signApproverNeedShow = null;
        } else {
          if (position.customerId === this.signNeedShow && position.userId === this.signApproverNeedShow) {
            const node = document.getElementById(`${position.contractSignId}-sign-${this.signNeedShow}-approver-${this.signApproverNeedShow}`);
            node.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });

          }
          this.signNeedShow = null;
          this.signApproverNeedShow = null;
        }

      }
    }

    // Da co chu ky anh tren he thong
    if (signaturePosition && signaturePosition.length > 0) {
      for (const position of signaturePosition) {
        const x = position.positionX;
        const y = position.positionY;
        const _width = position.widthRectangle;
        const _height = position.heightRectangle;
        const name = this.isOnAutoNumber ? this.configAutoNumber : (this.document.code ? this.document.code : this.message.getMessage('headertable.doc_code_required'));
        const id = position.id;
        const fontSize = position.fontSize;
        const fontFamily = position.fontFamily;
        const fontStyle = position.fontStyle;
        const elWidth = element.offsetWidth;
        const elHeight = element.offsetHeight;
        const htmlNode = this.getStampWrapper(x, y, _width, _height, name, id, elWidth, elHeight, '', fontSize, fontFamily, fontStyle, true, (position.contractSignId || position.idNumber), position.row_number);
        element.appendChild(htmlNode);
        if (position.id === this.signatureNeedShow) {
          const node = document.getElementById(`${this.signatureNeedShow}`);
          node.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
          this.signatureNeedShow = null;
        }
      }
    }

    element.addEventListener('mousedown', (eventMousedown) => {
      if (!this.isSelectPosition) {
        const target: HTMLElement = eventMousedown.target;
        if (target.id && target.id.includes('contract-code-config-') || target.id.includes('sign-') || (target.parentElement && target.parentElement.id && (target.parentElement.id.includes('sign-') || target.parentElement.id.includes('contract-code-config-')))) {
          const id = target.id ? target.id : target.parentElement.id;
          const indexApprover = id.indexOf('-approver-');
          const indexSign = id.indexOf('-sign-');
          const signId = id.slice(indexSign + 6, indexApprover);
          const userId = id.slice(indexApprover + 10);
          const signUuid = id.slice(0, indexSign);
          if(userId == 'undefined'){
            this.stopDrop = false;
          }
          else{
            const stopDropOld = [];
              this.listSign.filter(ele =>{
                if(!ele.role){
                  stopDropOld.push(ele)
                }
            });
if(stopDropOld.length > 0){
  if(stopDropOld[0].userId == userId ){
    this.stopDrop = false;
  }
  else {
    this.stopDrop = true;
  }
}
else {
  this.stopDrop = true;
}

          }
          if(this.stopDrop){
          if (target.className.includes('mat-icon')) {
            this.deleteSign(signId, userId, signUuid);
            if (target.id && target.id.includes('contract-code-config-') || (target.parentElement && target.parentElement.id && target.parentElement.id.includes('contract-code-config-'))) {
              this.deleteSignature(id);
            }
            return;
          }
          this.isSelectPosition = true;
          document.body.style.userSelect = 'none';
          const files = this.createContractMohaService.fileUploadArray.getValue();
          let idFile;
          if (files && files.length && files[this.activeFile]) {
            const file = files[this.activeFile] as any;
            idFile = file.id ? file.id : null;
          }
          this.signSelected = this.listSign.find(item => (item.enterpriseId == signId || item.customerId == signId) && item.fileId === idFile && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
          if (this.listSign.length) {
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              this.signSelected = this.listSign.find(item => {
                return (item.enterpriseId == signId || item.customerId == signId) && item.userId === userId && item.fileId === idFile && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId)
              });
            } else {
              this.signSelected = this.listSign.find(item => (item.enterpriseId === signId ||  item.customerId == signId) && item.fileId === idFile && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
            }
          } if (this.listSignature.length) {
            if (target.id && target.id.includes('contract-code-config-') || (target.parentElement && target.parentElement.id && target.parentElement.id.includes('contract-code-config-'))) {
              if (id !== null && id !== undefined && id !== 'undefined') {
                this.signatureSelected = this.listSignature.find(item => item.id === id && item.fileId === idFile);
              } else {
                this.signatureSelected = this.listSignature.find(item => item.id === id && item.fileId === idFile);
              }
            };
          }

          let idSign = (this.signSelected.contractSignId || this.signSelected.idNumber) +  '-sign-' + (this.signSelected.enterpriseId || this.signSelected.customerId) + '-approver-' + this.signSelected.userId
          let sign = document.getElementById(idSign)
          let position = {
            top: Number(sign.style.top.slice(0, -2)),
            left: Number(sign.style.left.slice(0, -2))
          }
          const node = document.getElementById(id);
          this.currentNodeSelected = node;
          if (node) {
            node.remove();
          }
          if (Object.keys(this.signSelected || {}).length) {
            this.showFramesNotification(this.signSelected, position);
          }
          if (Object.keys(this.signatureSelected || {}).length) {
            this.showFramesNotification(this.signatureSelected, true);
          }
        }
      }}
    });

    element.addEventListener('mouseup', (eventMouseup) => {
      for (let i = 0; i < element.childNodes.length; i++) {
        if (element.childNodes[i].nodeName == 'DIV' && element.childNodes[i]['id'] && element.childNodes[i]['id'].includes('contract-code-config-')) {
          if (this.listSignature && this.listSignature.length > 0) {
            this.listSignature.forEach((item) => {
              if (item.id == element.childNodes[i]['id']) {
                item.page === pageIndex;
              }

            });
            this.createContractMohaService.contractCodePositions.next(this.listSignature);
          };
          if (this.listSignatureTable && this.listSignatureTable.length > 0) {
            this.listSignatureTable.forEach((item) => {
              if (item.id == element.childNodes[i]['id']) {
                item.page === pageIndex;
              }

            });
            this.createContractMohaService.listSignatureTable.next(this.listSignatureTable);
          }
        }
      }

      if (this.isSelectPosition) {
        this.isSelectPosition = false;
        document.body.style.userSelect = 'auto';
        // xoá dòng chọn vị trí
        const framesNotification = document.getElementById('show-frames-notification');
        if (framesNotification) {
          framesNotification.remove();
        }
        const offsetParent = element.offsetParent.dataset;
        const { pageNumber } = offsetParent;
        const boundingClient = element.getBoundingClientRect();
        const { top, left } = boundingClient;
        let signatureWidth, signatureHeight, widthHeightRatio;
        widthHeightRatio = this.widthRectangle / this.heightRectangle;
        if (Object.keys(this.signSelected || {}).length) {
          signatureWidth = this.signSelected.widthRectangle * this.zoomLevel / 100;
          signatureHeight = this.signSelected.heightRectangle * this.zoomLevel / 100;
        }
        else if (Object.keys(this.signatureSelected || {}).length) {
          signatureWidth = this.signatureSelected.widthRectangle * this.zoomLevel / 100;
          signatureHeight = this.signatureSelected.heightRectangle * this.zoomLevel / 100;
        }
        let signZoom = this.zoomLevel / 100;
        let wrapperLeft = eventMouseup.clientX - signatureWidth / 2 - left;
        let wrapperTop = eventMouseup.clientY - signatureHeight / 2 - top;
        const newDiv = document.createElement('div');
        let contractSignId = this.signSelected.contractSignId || this.signSelected.idNumber
        if (Object.keys(this.signSelected || {}).length) {
          newDiv.setAttribute('id', `${contractSignId}-sign-${this.signSelected.enterpriseId || this.signSelected.customerId}-approver-${this.signSelected.userId}`);
          newDiv.style.width = `${signatureWidth}px`;
          newDiv.style.height = `${signatureHeight}px`;
          newDiv.style.fontFamily = 'Roboto';
        }
        else if (Object.keys(this.signatureSelected || {}).length) {

          newDiv.setAttribute('id', `${this.signatureSelected.id}`);
          newDiv.style.width = `${signatureWidth}px`;
          newDiv.style.height = `${signatureHeight}px`;
          if (this.signatureSelected.fontSize) {
            newDiv.style.fontSize = `${this.signatureSelected.fontSize}px`;
          }
          if (this.signatureSelected.fontFamily) {
            newDiv.style.fontFamily = this.signatureSelected.fontFamily;
          }
          if (this.signatureSelected.fontStyle && this.signatureSelected.fontStyle.includes('bold')) {
            newDiv.style.fontWeight = 'bold';
          }
          if (this.signatureSelected.fontStyle && this.signatureSelected.fontStyle.includes('italic')) {
            newDiv.style.fontStyle = 'italic';
          }
          if (this.signatureSelected.fontStyle && this.signatureSelected.fontStyle.includes('underline')) {
            newDiv.style.textDecoration = 'underline';
          }
        }
        if (wrapperLeft > 0) {
          newDiv.style.left = `${wrapperLeft}px`;
        }
        if (wrapperTop > 0) {
          newDiv.style.top = `${wrapperTop}px`;
        }
        newDiv.style.background = 'rgb(0,0,0,0.2)';
        newDiv.style.zIndex = '1';
        newDiv.style.border = '1px solid #999999';
        newDiv.style.lineHeight = '1.9';
        newDiv.style.color = '#00f';
        if (this.documentCodeNull && !this.isOnAutoNumber) {
          newDiv.style.color = 'red';
        } else {
          newDiv.style.color = '#00f';
        }
        newDiv.style.padding = `${10 * signZoom}px`;
        newDiv.style.position = 'absolute';
        newDiv.style.minWidth = `calc(300px / 10 * 3 * ${this.zoomLevel / 100})`;
        newDiv.style.minHeight = `calc(136px / 10 * 3 * ${this.zoomLevel / 100})`;
        newDiv.className = 'no-user-select';
        if (Object.keys(this.signSelected || {}).length) {
          this.getOffClose(this.signSelected);
          if(this.signSelected.row_number && this.stopClose){
            this.renderTextContent(newDiv, `${this.message.getMessage('signature')} ${this.signSelected.name} ${this.message.getMessage('number_sign')} ${this.signSelected.row_number}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
          }else {
            this.renderTextContent(newDiv, `${this.message.getMessage('signature')} ${this.signSelected.name}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; height: 100%; color: #00f; cursor: move;`);
          }
        }
        else if (Object.keys(this.signatureSelected || {}).length) {
          // newDiv.style.whiteSpace = 'nowrap';
          // newDiv.style.minWidth ='fit-content';
          newDiv.style.wordBreak = 'break-word';

          if (this.documentCodeNull && !this.isOnAutoNumber) {
            this.renderTextContent(newDiv, this.isOnAutoNumber ? this.configAutoNumber : this.message.getMessage('headertable.doc_code_required'), `font-size: ${(this.signatureSelected.fontSize ? this.signatureSelected.fontSize : 12) * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; align-items: start; text-align: left; height: 100%; cursor: move;`, { closeIconSize: 30 * signZoom, contentClass: 'text-danger' });
          } else {
            this.renderTextContent(newDiv, this.isOnAutoNumber ? this.configAutoNumber : this.document.code, `font-size: ${(this.signatureSelected.fontSize ? this.signatureSelected.fontSize : 12) * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; align-items: start; text-align: left; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
          }
        }
        this.changeDataToTable()
        //         Thay dổi kích thước chân ký
        const resizer = document.createElement('div');
        if(this.stopClose){
          resizer.setAttribute('class', 'resize-div-bot-right');
        }
        resizer.style.setProperty('--zoom', (signZoom).toString());
        newDiv.appendChild(resizer);
        element.appendChild(newDiv);

        let startX, startY;
        let signId;
        let indexApprover;
        let userId;
        let idSignature;
        let signUuid;

        resizer.addEventListener('mousedown', (e) => {
          e.stopPropagation();
          startX = e.clientX;
          startY = e.clientY;
          document.documentElement.addEventListener('mousemove', doDrag);
          document.documentElement.addEventListener('mouseup', stopDrag);
          const targetSignId = e.target as Element;
          if (targetSignId.parentElement.id && targetSignId.parentElement.id.includes('contract-code-config-')) {
            idSignature = targetSignId.parentElement.id;
          }

           indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
           const indexSign = targetSignId.parentElement.id.indexOf('-sign-');
           signId = targetSignId.parentElement.id.slice(indexSign + 6, indexApprover);
           userId = targetSignId.parentElement.id.slice(indexApprover + 10);
           signUuid = targetSignId.parentElement.id.slice(0, indexSign);
        });

        // const signSelected = this.listSign.filter(item => item.enterpriseId === signId);

        let baseWidth = newDiv.offsetWidth;
        let baseHeight = newDiv.offsetHeight;

        const rerenderSign = () => {
          let signSelected, signatureSelected;
          if (this.listSign.length) {
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId) && item.userId === userId && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
            } else {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
            }
          } if (this.listSignature.length) {
            if (idSignature) {
              signatureSelected = this.listSignature.filter(item => item.id === idSignature);
            }
          }
          if (Object.keys(signSelected || {}).length && !Object.keys(signatureSelected || {}).length) {
            this.getOffClose(signSelected[0]);
            if(signSelected[0].row_number && this.stopClose){
              this.renderTextContent(newDiv, `${this.message.getMessage('signature')} ${signSelected[0].name} ${this.message.getMessage('number_sign')} ${signSelected[0].row_number}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
            }else {
              this.renderTextContent(newDiv, `${this.message.getMessage('signature')} ${signSelected[0].name}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; height: 100%; color: #00f; cursor: move;`);
            }
          } else if (Object.keys(this.signatureSelected || {}).length) {
            // newDiv.style.whiteSpace = 'nowrap';
            // newDiv.style.minWidth ='fit-content';
            newDiv.style.wordBreak = 'break-word';
            this.renderTextContent(newDiv, this.isOnAutoNumber ? this.configAutoNumber : this.document.code, `font-size: ${(this.signatureSelected.fontSize ? this.signatureSelected.fontSize : 12) * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; align-items: start; text-align: left; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
          }

          newDiv.appendChild(resizer);
          resizer.style.removeProperty('--zoom');
          resizer.style.setProperty('--zoom', (signZoom).toString());
          return;
        }

        const doDrag = (e) => {
          e.stopPropagation();
          let signSelected, signatureSelected;
          if (this.listSign.length) {
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
            } else {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
            };
          }
          if (this.listSignature.length) {
            if (idSignature) {
              signatureSelected = this.listSignature.filter(item => item.id === idSignature);
            }
          }
          if (Object.keys(signSelected || {}).length && !Object.keys(signatureSelected || {}).length) {
            signatureWidth = signSelected[0].widthRectangle * this.zoomLevel / 100;
            signatureHeight = signSelected[0].heightRectangle * this.zoomLevel / 100;
            newDiv.style.width = (signatureWidth + e.clientX - startX) + 'px';
            newDiv.style.height = (signatureHeight + e.clientY - startY) + 'px';
            let widthHeightRatio_Drag = newDiv.offsetWidth / newDiv.offsetHeight;
            if (widthHeightRatio !== widthHeightRatio_Drag) {
              newDiv.style.height = (newDiv.offsetWidth / widthHeightRatio) + 'px';
              newDiv.style.width = (newDiv.offsetHeight * widthHeightRatio) + 'px';
            }
          } else if (Object.keys(signatureSelected || {}).length) {
            signatureWidth = signatureSelected[0].widthRectangle * this.zoomLevel / 100;
            signatureHeight = signatureSelected[0].heightRectangle * this.zoomLevel / 100;
            newDiv.style.width = (signatureWidth + e.clientX - startX) + 'px';
            newDiv.style.height = (signatureHeight + e.clientY - startY) + 'px';
          }

          newDiv.style.maxWidth = (element.offsetWidth - wrapperLeft) + 'px';
          newDiv.style.maxHeight = (element.offsetHeight - wrapperTop) + 'px';
          rerenderSign();
        }

        const stopDrag = (e) => {
          e.stopPropagation();
          if (newDiv.offsetWidth / 2 + wrapperLeft < 0 || newDiv.offsetHeight / 2 + wrapperTop < 0) {
            newDiv.style.width = baseWidth + 'px';
            newDiv.style.height = baseHeight + 'px';
          } else {
            baseWidth = newDiv.offsetWidth;
            baseHeight = newDiv.offsetHeight;
          }
          rerenderSign();
          if (this.listSign.length) {
            this.listSign.forEach(item => {
              if ((item.enterpriseId === signId || item.customerId === signId) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId))) {
                item.widthRectangle = newDiv.offsetWidth * 100 / this.zoomLevel;
                item.heightRectangle = newDiv.offsetHeight * 100 / this.zoomLevel;
              }
            });
            this.createContractMohaService.signPositions.next(this.listSign);
          }

          if (this.listSignature.length) {
            this.listSignature.forEach(item => {
              if (item.id === idSignature) {
                item.widthRectangle = newDiv.offsetWidth * 100 / this.zoomLevel;
                item.heightRectangle = newDiv.offsetHeight * 100 / this.zoomLevel;
              }
            });
            this.createContractMohaService.contractCodePositions.next(this.listSignature);
          }
          document.documentElement.removeEventListener('mousemove', doDrag);
          document.documentElement.removeEventListener('mouseup', stopDrag);
        }

        const zoomLevel = this.zoomLevel;
        const files = this.createContractMohaService.fileUploadArray.getValue();
        let id;
        if (files && files.length && files[this.activeFile]) {
          const file = files[this.activeFile] as any;
          id = file.id ? file.id : null;
        }
        if (this.listSign.length && Object.keys(this.signSelected || {}).length) {
          this.listSign.forEach(item => {
            if (((item.enterpriseId === this.signSelected.enterpriseId && this.signSelected.enterpriseId) ||
            (item.customerId === this.signSelected.customerId && this.signSelected.customerId)) &&
            item.userId === this.signSelected.userId && item.fileId === id  &&
            ((item.contractSignId && this.signSelected.contractSignId === item.contractSignId) || (this.signSelected.idNumber === item.idNumber && item.idNumber))) {


              item.stampPositionLeft = eventMouseup.clientX - signatureWidth / 2 - left;
              item.stampPositionTop = eventMouseup.clientY - signatureHeight / 2 - top;
              item.positionX = 100 * wrapperLeft / zoomLevel;
              item.positionY = 100 * wrapperTop / zoomLevel;
              item.pageIndex = pageIndex;
              item.zoom = this.zoomLevel / 100;
              item.pdfSrc = this.pdfSrc;
              item.pageNumber = pageNumber;
              item.widthRectangle = newDiv.offsetWidth * 100 / this.zoomLevel;
              item.heightRectangle = newDiv.offsetHeight * 100 / this.zoomLevel;
            }
          });
          this.signSelected = null;
          this.createContractMohaService.signPositions.next(this.listSign);
        }
        if (this.listSignature.length && Object.keys(this.signatureSelected || {}).length) {
          this.listSignature.forEach((item, idx) => {
            if (item.id === this.signatureSelected.id && item.fileId === id) {
              item.stampPositionLeft = eventMouseup.clientX - signatureWidth / 2 - left;
              item.stampPositionTop = eventMouseup.clientY - signatureHeight / 2 - top;
              item.positionX = 100 * wrapperLeft / zoomLevel;
              item.positionY = 100 * wrapperTop / zoomLevel;
              item.pageIndex = pageIndex;
              item.zoom = this.zoomLevel / 100;
              item.pdfSrc = this.pdfSrc;
              item.pageNumber = pageNumber;
              item.page = pageIndex;
              item.widthRectangle = newDiv.offsetWidth * 100 / this.zoomLevel;
              item.heightRectangle = newDiv.offsetHeight * 100 / this.zoomLevel;
              this.listSignatureTable[idx].page = pageIndex;
            }
          });
          this.signatureSelected = null;
          this.createContractMohaService.contractCodePositions.next(this.listSignature);
          this.createContractMohaService.listSignatureTable.next(this.listSignatureTable);
        }
      }
      this.changeDataToTable()
    })
    element.addEventListener('click', (clickEvent) => {
      if (!this.isSelectPosition) {
        const target: HTMLElement = clickEvent.target;
        if (target.id && target.id.includes('contract-code-config-') || target.id.includes('sign-') || (target.parentElement && target.parentElement.id && (target.parentElement.id.includes('sign-') || target.parentElement.id.includes('contract-code-config-')))) {
          const id = target.id ? target.id : target.parentElement.id;
          // const indexApprover = id.indexOf('-approver-');
          // const signId = id.slice(5, indexApprover);
          // const userId = id.slice(indexApprover + 10);
          const indexApprover = id.indexOf('-approver-');
          const indexSign = id.indexOf('-sign-');
          const signId = id.slice(indexSign + 6, indexApprover);
          const userId = id.slice(indexApprover + 10);
          const signUuid = id.slice(0, indexSign); // todo

          if (target.className.includes('mat-icon')) {
            this.deleteSign(signId, userId, signUuid);
            if (target.id && target.id.includes('contract-code-config-') || (target.parentElement && target.parentElement.id && target.parentElement.id.includes('contract-code-config-'))) {
              this.deleteSignature(id);
            }
            return;
          }
        }
      }
    });
    element.addEventListener('mouseleave', (mouseoverEvent) => {
      this.isMouseLeave = true;
      if (this.isSelectPosition) {
        const nodeOther = document.getElementById('show-frames-notification');
        if (nodeOther) {
          nodeOther.remove();
        }
      }
    });
    element.addEventListener('mouseover', () => {
      this.isMouseLeave = false;
    });
    element.addEventListener('wheel', (wheelEvent) => {
      if (this.isSelectPosition) {
        let node = element.querySelector('#show-frames-notification');
        const nodeOther = document.getElementById('show-frames-notification');
        if (!node && nodeOther) {
          nodeOther.remove();
        }
        const boundingClient = element.getBoundingClientRect();
        const { top, left } = boundingClient;
        let signatureWidth, signatureHeight;
        if (Object.keys(this.signSelected || {}).length && !Object.keys(this.signatureSelected || {}).length) {
          signatureWidth = this.signSelected.widthRectangle * this.zoomLevel / 100;
          signatureHeight = this.signSelected.heightRectangle * this.zoomLevel / 100;
        }
        else if (Object.keys(this.signatureSelected || {}).length) {
          signatureWidth = this.signatureSelected.widthRectangle * this.zoomLevel / 100;
          signatureHeight = this.signatureSelected.heightRectangle * this.zoomLevel / 100;
        }

        let signZoom = this.zoomLevel / 100;
        const widthHeightRatio = this.widthRectangle / this.heightRectangle;
        if (!node) {
          const stampNode = document.createElement('div');
          if (Object.keys(this.signSelected || {}).length && !Object.keys(this.signatureSelected || {}).length) {
            this.getOffClose(this.signSelected);
            if(this.signSelected.row_number && this.stopClose){
              this.renderTextContent(stampNode, `${this.message.getMessage('signature')} ${this.signSelected && this.signSelected.name ? this.signSelected.name : ''} ${this.message.getMessage('number_sign')} ${this.signSelected.row_number}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`, { notification: { text: this.translateService.instant('messages.click_to_select_sign_position'), style: `position: absolute; top: -${35 * signZoom}px; left: ${(this.signSelected.widthRectangle / 2 - 150) * signZoom}px; color: red; width: ${300 * signZoom}px;` } });
            }
            else {
              this.renderTextContent(stampNode, `${this.message.getMessage('signature')} ${this.signSelected && this.signSelected.name ? this.signSelected.name : ''}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`, { notification: { text: this.translateService.instant('messages.click_to_select_sign_position'), style: `position: absolute; top: -${35 * signZoom}px; left: ${(this.signSelected.widthRectangle / 2 - 150) * signZoom}px; color: red; width: ${300 * signZoom}px;` } });
            }
            stampNode.style.width = `${signatureWidth}px`;
            stampNode.style.height = `${signatureHeight}px`;
          } else if (Object.keys(this.signatureSelected || {}).length) {
            // stampNode.style.whiteSpace = 'nowrap';
            // stampNode.style.minWidth ='fit-content';
            stampNode.style.wordBreak = 'break-word';
            this.renderTextContent(stampNode, this.isOnAutoNumber ? this.configAutoNumber : this.document.code, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; color: #00f; cursor: move;`, { notification: { text: this.currentNodeSelected ? '' : this.translateService.instant('messages.click_to_select_sign_position'), style: `position: absolute; top: -${35 * signZoom}px; left: ${(this.signatureSelected.widthRectangle / 2 - 150) * signZoom}px; color: red; width: ${300 * signZoom}px;` } });
          }
          this.stampWrapper = stampNode;
          stampNode.style.width = `${signatureWidth}px`;
          stampNode.style.height = `${signatureHeight}px`;
          stampNode.style.position = 'absolute';
          stampNode.setAttribute('id', 'show-frames-notification');
          stampNode.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
          stampNode.style.top = `${(wheelEvent.clientY - signatureHeight / 2 - top)}px`;
          stampNode.style.zIndex = '1';
          stampNode.style.background = 'rgb(0,0,0,0.2)';
          stampNode.style.border = '1px solid';
          stampNode.style.lineHeight = '1.9';
          stampNode.style.color = '#00f';
          stampNode.style.fontFamily = 'Roboto';
          stampNode.style.padding = `${10 * this.zoomLevel / 100}px`;
          stampNode.style.minWidth = `calc(300px / 10 * 3 * ${this.zoomLevel / 100})`;
          stampNode.style.minHeight = `calc(136px / 10 * 3 * ${this.zoomLevel / 100})`;
          stampNode.className = 'no-user-select';
          //         Thay dổi kích thước chân ký
          const resizer = document.createElement('div');
          if(this.stopClose){
            resizer.setAttribute('class', 'resize-div-bot-right');
          }

          resizer.style.setProperty('--zoom', (signZoom).toString());
          stampNode.appendChild(resizer);
          element.appendChild(stampNode);

          let startX;
          let startY;
          let signId;
          let indexApprover;
          let userId;
          let idSignature;
          let signUuid;
          resizer.addEventListener('mousedown', (e) => {
            e.stopPropagation();
            startX = e.clientX;
            startY = e.clientY;
            document.documentElement.addEventListener('mousemove', doDrag);
            document.documentElement.addEventListener('mouseup', stopDrag);
            const targetSignId = e.target as Element;
            if (targetSignId.parentElement.id && targetSignId.parentElement.id.includes('contract-code-config-')) {
              idSignature = targetSignId.parentElement.id;
            }
            // indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
            // signId = targetSignId.parentElement.id.slice(5, indexApprover);
            // userId = targetSignId.parentElement.id.slice(indexApprover + 10);

            indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
            const indexSign = targetSignId.parentElement.id.indexOf('-sign-');
            signId = targetSignId.parentElement.id.slice(indexSign + 6, indexApprover);
            userId = targetSignId.parentElement.id.slice(indexApprover + 10);
            signUuid = targetSignId.parentElement.id.slice(0, indexSign);
          });

          let baseWidth = stampNode.offsetWidth;
          let baseHeight = stampNode.offsetHeight;

          const rerenderSign = () => {
            let signSelected, signatureSelected;
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId ) && item.userId === userId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
            } else {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId)));
            };
            if (idSignature) {
              signatureSelected = this.listSignature.filter(item => item.id === idSignature);
            }
            if (Object.keys(this.signSelected || {}).length && !Object.keys(this.signatureSelected || {}).length) {
              this.getOffClose(this.signSelected[0]);
              if(this.signSelected[0].row_number && this.stopClose){
                this.renderTextContent(stampNode, `${this.message.getMessage('signature')} ${signSelected[0].name} ${this.message.getMessage('number_sign')} ${this.signSelected[0].row_number}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
              }
              else {
                this.renderTextContent(stampNode, `${this.message.getMessage('signature')} ${signSelected[0].name}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`);
              }
            } else if (Object.keys(this.signatureSelected || {}).length) {
              // stampNode.style.whiteSpace = 'nowrap';
              // stampNode.style.minWidth ='fit-content';
              stampNode.style.wordBreak = 'break-word';
              this.renderTextContent(stampNode, this.isOnAutoNumber ? this.configAutoNumber : this.document.code, `font-size: ${(this.signatureSelected.fontSize ? this.signatureSelected.fontSize : 12) * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
            }

            stampNode.appendChild(resizer);
            resizer.style.removeProperty('--zoom');
            resizer.style.setProperty('--zoom', (signZoom).toString());
            return;
          }

          const doDrag = (e) => {
            e.stopPropagation();
            let signSelected, signatureSelected;
            if (userId !== null && userId !== undefined && userId !== 'undefined') {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId ) && item.userId === userId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
            } else {
              signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId)));
            }
            if (idSignature) {
              signatureSelected = this.listSignature.filter(item => item.id === idSignature);
            }
            if (Object.keys(this.signSelected || {}).length && !Object.keys(this.signatureSelected || {}).length) {
              signatureHeight = signSelected[0].heightRectangle * this.zoomLevel / 100;
              signatureWidth = signSelected[0].widthRectangle * this.zoomLevel / 100;
            } else if (Object.keys(this.signatureSelected || {}).length) {
              signatureHeight = signatureSelected[0].heightRectangle * this.zoomLevel / 100;
              signatureWidth = signatureSelected[0].widthRectangle * this.zoomLevel / 100;
            }

            stampNode.style.width = (signatureWidth + e.clientX - startX) + 'px';
            stampNode.style.height = (signatureWidth + e.clientY - startY) + 'px';
            stampNode.style.maxWidth = (element.offsetWidth - stampNode.offsetLeft) + 'px';
            stampNode.style.maxHeight = (element.offsetHeight - stampNode.offsetTop) + 'px';
            rerenderSign();
          }

          const stopDrag = (e) => {
            e.stopPropagation();
            if (stampNode.offsetWidth / 2 + stampNode.offsetLeft < 0 || stampNode.offsetHeight / 2 + stampNode.offsetTop < 0) {
              stampNode.style.width = baseWidth + 'px';
              stampNode.style.height = baseHeight + 'px';
            } else {
              baseWidth = stampNode.offsetWidth;
              baseHeight = stampNode.offsetHeight;
            }

            rerenderSign();
            if (this.listSign.length) {
              this.listSign.forEach(item => {
                if ((item.enterpriseId === signId || item.customerId === signId ) && item.userId === userId && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId)) {
                  item.widthRectangle = stampNode.offsetWidth * 100 / this.zoomLevel;
                  item.heightRectangle = stampNode.offsetHeight * 100 / this.zoomLevel;
                }
              });
              this.createContractMohaService.signPositions.next(this.listSign);
            }
            if (this.listSignature.length) {
              this.listSignature.forEach(item => {
                if (item.id == idSignature) {
                  item.widthRectangle = stampNode.offsetWidth * 100 / this.zoomLevel;
                  item.heightRectangle = stampNode.offsetHeight * 100 / this.zoomLevel;
                }
              });
              this.createContractMohaService.contractCodePositions.next(this.listSignature);
            }

            document.documentElement.removeEventListener('mousemove', doDrag);
            document.documentElement.removeEventListener('mouseup', stopDrag);
          }

          element.appendChild(stampNode);
        } else {
          node.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
          node.style.top = `${(wheelEvent.clientY - signatureHeight / 2 - top)}px`;
        }
      }
    });
    element.addEventListener('mousemove', (mousemoveEvent) => {
      if (this.isSelectPosition && this.stopDrop) {
        // xoá dòng chọn vị trí
        const node = element.querySelector('#show-frames-notification');
        const nodeOther = document.getElementById('show-frames-notification');
        if (!node && nodeOther) {
          nodeOther.remove();
        }
        const boundingClient = element.getBoundingClientRect();
        const { top, left } = boundingClient;
        let signatureWidth, signatureHeight;
        if (Object.keys(this.signSelected || {}).length && !Object.keys(this.signatureSelected || {}).length) {
          signatureWidth = this.signSelected.widthRectangle * this.zoomLevel / 100;
          signatureHeight = this.signSelected.heightRectangle * this.zoomLevel / 100;
        } else if (Object.keys(this.signatureSelected || {}).length) {
          signatureWidth = this.signatureSelected.widthRectangle * this.zoomLevel / 100;
          signatureHeight = this.signatureSelected.heightRectangle * this.zoomLevel / 100;
        }

        let signZoom = this.zoomLevel / 100;
        if (!node) {
          const stampNode = document.createElement('div');
          if (Object.keys(this.signSelected || {}).length && !Object.keys(this.signatureSelected || {}).length) {
            this.getOffClose(this.signSelected);
            if(this.signSelected.row_number && this.stopClose){
              this.renderTextContent(stampNode, `${this.message.getMessage('signature')} ${this.signSelected && this.signSelected.name ? this.signSelected.name : ''} ${this.message.getMessage('number_sign')} ${this.signSelected.row_number}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: red; cursor: move;`, { notification: { text: '', style: `position: absolute; top: -${35 * signZoom}px; left: ${(this.signSelected.widthRectangle / 2 - 150) * signZoom}px; color: red; width: ${300 * signZoom}px;` } });
            }
            else {
              this.renderTextContent(stampNode, `${this.message.getMessage('signature')} ${this.signSelected && this.signSelected.name ? this.signSelected.name : ''}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: red; cursor: move;`, { notification: { text: '', style: `position: absolute; top: -${35 * signZoom}px; left: ${(this.signSelected.widthRectangle / 2 - 150) * signZoom}px; color: red; width: ${300 * signZoom}px;` } });
            }
          } else if (Object.keys(this.signatureSelected || {}).length) {
            // stampNode.style.whiteSpace = 'nowrap';
            // stampNode.style.minWidth ='fit-content';

            stampNode.style.wordBreak = 'break-word';
            if (this.documentCodeNull && !this.isOnAutoNumber) {
              this.renderTextContent(stampNode, this.isOnAutoNumber ? this.configAutoNumber : this.message.getMessage('headertable.doc_code_required'), `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; cursor: move;`, { contentClass: 'text-danger' });
            } else {
              this.renderTextContent(stampNode, this.isOnAutoNumber ? this.configAutoNumber : this.document.code, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; color: #00f; height: 100%; cursor: move;`);
            }
          }
          stampNode.style.width = `${signatureWidth}px`;
          stampNode.style.height = `${signatureHeight}px`;
          stampNode.style.position = 'absolute';
          stampNode.setAttribute('id', 'show-frames-notification');
          stampNode.style.left = `${(mousemoveEvent.clientX - signatureWidth / 2 - left)}px`;
          stampNode.style.top = `${(mousemoveEvent.clientY - signatureHeight / 2 - top)}px`;
          stampNode.style.zIndex = '1';
          stampNode.style.background = 'rgb(0,0,0,0.2)';
          stampNode.style.border = '1px solid';
          stampNode.style.lineHeight = '1.9';
          if (this.documentCodeNull && !this.isOnAutoNumber) {
            stampNode.style.color = 'red';
          } else {
            stampNode.style.color = '#00f';
          }
          stampNode.style.fontFamily = 'Roboto';
          stampNode.style.padding = `${10 * signZoom}px`;
          stampNode.className = 'no-user-select';

          element.appendChild(stampNode);

        } else {
          node.style.left = `${(mousemoveEvent.clientX - signatureWidth / 2 - left)}px`;
          node.style.top = `${(mousemoveEvent.clientY - signatureHeight / 2 - top)}px`;
        }
      }
    });
    element.style.opacity = '1';
    element.setAttribute('id', `text-pdf-layer-${pageIndex}-${this.activeFile}`);
    this.maxPageCurrent = pageIndex;
    this.changeDataToTable()
  }

  openPDFByBrowser(id: string) {
    if (id) {
      this.documentService.downloadFileZip(id).subscribe(res => {
        if (window.top.navigator.msSaveOrOpenBlob) {
          // Store Blob in IE
          window.top.navigator.msSaveOrOpenBlob(res, this.document.name + '.zip');
        } else {
          // Store Blob in others
          const tA = document.body.appendChild(document.createElement('a'));
          tA.href = URL.createObjectURL(res);
          tA.download = this.document.code + ' - ' + this.document.name + '.zip';
          tA.style.display = 'none';
          tA.click();
          tA.parentNode.removeChild(tA);
        }
      });
    }
  }
  async doPrint() {
    this.changePrintf.emit("printf");
  }

  getStampWrapper(positionX: number, positionY: number, width: number, height: number, name: string, id: number, elWidth: number, elHeight: number, idUser?: any, fontSize?: any, fontFamily?: any, fontStyle?: any[], isContractCodeConfig = false, uuid: string = '', row_number:any = '') {
    const stampNode = document.createElement('div');
    if (!isContractCodeConfig) {
      stampNode.setAttribute('id', `${uuid}-sign-${id}-approver-${idUser}`);
    } else {
      //neu la cau hinh ma hop dong
      stampNode.setAttribute('id', `${id}`);
    }


    let signatureWidth = width * this.zoomLevel / 100;
    let signatureHeight = height * this.zoomLevel / 100;

    const wrapperLeft = (positionX * this.zoomLevel) / 100;
    const wrapperTop = (positionY * this.zoomLevel) / 100;
    let signZoom = this.zoomLevel / 100;
    const widthHeightRatio = width / height;
    stampNode.style.position = 'absolute';
    stampNode.style.left = `${wrapperLeft}px`;
    stampNode.style.top = `${wrapperTop}px`;
    if (!isContractCodeConfig) {
      stampNode.style.width = `${signatureWidth}px`;
      stampNode.style.height = `${signatureHeight}px`;
      // stampNode.style.color = '#00f';
    }
    stampNode.style.minWidth = `calc(300px / 10 * 3 * ${this.zoomLevel / 100})`;
    stampNode.style.minHeight = `calc(136px / 10 * 3 * ${this.zoomLevel / 100})`;
    stampNode.style.background = 'rgb(0,0,0,0.2)';
    stampNode.style.zIndex = '1';
    stampNode.style.border = '1px solid #999999';
    stampNode.style.lineHeight = '1.9';
    stampNode.style.color = '#00f';

    if (fontSize) {
      stampNode.style.fontSize = fontSize;
    };
    if (fontFamily) {
      stampNode.style.fontFamily = fontFamily;
    } else {
      stampNode.style.fontFamily = 'Roboto';
    };
    if (fontStyle && fontStyle.includes('bold')) {
      stampNode.style.fontWeight = 'bold';
    }
    if (fontStyle && fontStyle.includes('italic')) {
      stampNode.style.fontStyle = 'italic';
    }
    if (fontStyle && fontStyle.includes('underline')) {
      stampNode.style.textDecoration = 'underline';
    }
    stampNode.style.padding = `${10 * signZoom}px`;
    stampNode.className = 'no-user-select';
    if (isContractCodeConfig) {
      stampNode.style.width = `${signatureWidth}px`;
      stampNode.style.height = `${signatureHeight}px`;
      if (this.documentCodeNull && !this.isOnAutoNumber) {
        stampNode.style.color = 'red';
      }
      // stampNode.style.whiteSpace = 'nowrap';
      // stampNode.style.minWidth ='fit-content';
      stampNode.style.wordBreak = 'break-word';
      if (this.documentCodeNull && !this.isOnAutoNumber) {
        this.renderTextContent(stampNode, name, `font-size: ${(fontSize ? fontSize : 12) * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; cursor: move;`, { closeIconSize: 30 * signZoom, contentClass: 'text-danger' });
      } else {
        this.renderTextContent(stampNode, name, `font-size: ${(fontSize ? fontSize : 12) * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
      }

    } else {
      const data ={
        userId:idUser
      }
      this.getOffClose(data);
      if(row_number && this.stopClose){
        this.renderTextContent(stampNode, `${this.message.getMessage('signature')} ${name} ${this.message.getMessage('number_sign')} ${row_number}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
      }
      else {
        this.renderTextContent(stampNode, `${this.message.getMessage('signature')} ${name}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`);
      }

      stampNode.style.display = 'flex';
      stampNode.style.justifyContent = 'center';
      stampNode.style.flexDirection = 'column';
      stampNode.style.textAlign = 'center';
      stampNode.style.fontWeight = 'bold';
    };
    //         Thay dổi kích thước chân ký

    const resizer = document.createElement('div');
    // resizer.setAttribute('class', 'resize-div-bot-right');
    if(this.stopClose){
      resizer.setAttribute('class', 'resize-div-bot-right');
    }
    resizer.style.setProperty('--zoom', (signZoom).toString());
    stampNode.appendChild(resizer);
    let startX, startY, signId, userId, indexApprover, idSignature, signUuid;
    resizer.addEventListener('mousedown', (e) => {
      e.stopPropagation();
      startX = e.clientX;
      startY = e.clientY;
      document.documentElement.addEventListener('mousemove', doDrag);
      document.documentElement.addEventListener('mouseup', stopDrag);
      const targetSignId = e.target as Element;
      //la cau hinh ma hop dong
      if (isContractCodeConfig) {
        if (targetSignId.parentElement.id && targetSignId.parentElement.id.includes('contract-code-config-')) {
          idSignature = targetSignId.parentElement.id;
        }
      } else {
        indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
        const indexSign = targetSignId.parentElement.id.indexOf('-sign-');
        signId = targetSignId.parentElement.id.slice(indexSign + 6, indexApprover);
        userId = targetSignId.parentElement.id.slice(indexApprover + 10);
        signUuid = targetSignId.parentElement.id.slice(0, indexSign);
      }

    });

    let baseWidth = signatureWidth;
    let baseHeight = signatureHeight;

    const rerenderSign = () => {
      let signSelected, signatureSelected;
      if (this.listSign.length) {
        if (userId !== null && userId !== undefined && userId !== 'undefined') {
          signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId ) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId)));
        } else {
          signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId))));
        };
      } if (this.listSignature.length) {

        if (idSignature !== null && idSignature !== undefined && idSignature !== 'undefined') {
          signatureSelected = this.listSignature.filter(item => item.id == idSignature);
        };
      }
      if (isContractCodeConfig) {
        //   stampNode.style.whiteSpace = 'nowrap';
        //   stampNode.style.minWidth ='fit-content';
        const signSelected = this.listSignature.filter(item => item.id === id);
        stampNode.style.wordBreak = 'break-word';
        this.renderTextContent(stampNode, this.isOnAutoNumber ? this.configAutoNumber : this.document.code, `font-size: ${(fontSize === 12 ? signSelected[0].fontSize : fontSize) * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
      } else {
        this.getOffClose(signSelected[0]);
       if(signSelected[0].row_number && this.stopClose){
         this.renderTextContent(stampNode, `${this.message.getMessage('signature')} ${signSelected[0].name} ${this.message.getMessage('number_sign')} ${signSelected[0].row_number}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
       }
       else {
         this.renderTextContent(stampNode, `${this.message.getMessage('signature')} ${signSelected[0].name}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`);
       }
      }
      stampNode.appendChild(resizer);
      resizer.style.removeProperty('--zoom');
      resizer.style.setProperty('--zoom', (signZoom).toString());
      return;
    }

    const doDrag = (e) => {
      e.stopPropagation();
      let signSelected, signatureSelected;
      if (this.listSign.length) {
        if (userId !== null && userId !== undefined && userId !== 'undefined') {
          signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId ) && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
        } else {
          signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId) && ((item.idNumber && signUuid == item.idNumber) || signUuid == item.contractSignId));
        }
      } if (this.listSignature.length) {
        if (idSignature !== null && idSignature !== undefined && idSignature !== 'undefined') {
          signatureSelected = this.listSignature.filter(item => item.id == idSignature);
        };
      }
      //neu la cau hinh ma hop dong
      if (isContractCodeConfig) {
        signatureHeight = signatureSelected[0].heightRectangle * this.zoomLevel / 100;
        signatureWidth = signatureSelected[0].widthRectangle * this.zoomLevel / 100;
        stampNode.style.width = (signatureWidth + e.clientX - startX) + 'px';
        stampNode.style.height = (signatureHeight + e.clientY - startY) + 'px';
      } else {
        signatureHeight = signSelected[0].heightRectangle * this.zoomLevel / 100;
        signatureWidth = signSelected[0].widthRectangle * this.zoomLevel / 100;
        stampNode.style.width = (signatureWidth + e.clientX - startX) + 'px';
        stampNode.style.height = (signatureHeight + e.clientY - startY) + 'px';
        let widthHeightRatio_Drag = stampNode.offsetWidth / stampNode.offsetHeight;
        if (widthHeightRatio !== widthHeightRatio_Drag) {
          stampNode.style.height = (stampNode.offsetWidth / widthHeightRatio) + 'px';
          stampNode.style.width = (stampNode.offsetHeight * widthHeightRatio) + 'px';
        }
      }

      stampNode.style.maxWidth = (elWidth - stampNode.offsetLeft) + 'px';
      stampNode.style.maxHeight = (elHeight - stampNode.offsetTop) + 'px';

      rerenderSign();
    }

    const stopDrag = (e) => {
      e.stopPropagation();
      if (stampNode.offsetWidth / 2 + wrapperLeft < 0 || stampNode.offsetHeight / 2 + wrapperTop < 0) {
        stampNode.style.width = baseWidth + 'px';
        stampNode.style.height = baseHeight + 'px';
      } else {
        baseWidth = stampNode.offsetWidth;
        baseHeight = stampNode.offsetHeight;
      }

      rerenderSign();
      //neu la cau hinh ma hop dong
      if (isContractCodeConfig && this.listSignature) {
        this.listSignature.forEach(item => {
          if (item.id === idSignature) {
            item.widthRectangle = stampNode.offsetWidth * 100 / this.zoomLevel;
            item.heightRectangle = stampNode.offsetHeight * 100 / this.zoomLevel;
          }
        });
        this.createContractMohaService.contractCodePositions.next(this.listSignature);
      } else if (this.listSign.length) {
        this.listSign.forEach(item => {
          if ((item.enterpriseId === signId || item.customerId === signId ) && ((item.idNumber && signUuid == item.idNumber) || (signUuid == item.contractSignId && item.contractSignId))) {
            item.widthRectangle = stampNode.offsetWidth * 100 / this.zoomLevel;
            item.heightRectangle = stampNode.offsetHeight * 100 / this.zoomLevel;
          }
        });
        this.createContractMohaService.signPositions.next(this.listSign);
      }
      document.documentElement.removeEventListener('mousemove', doDrag);
      document.documentElement.removeEventListener('mouseup', stopDrag);
    }

    return stampNode;
  }

  // render a element signature
  getStampWrapperForm(positionX: number, positionY: number, width: number, height: number, name: string, id: number, elWidth: number, elHeight: number, element: Element) {
    const stampNode = document.createElement('div');
    stampNode.setAttribute('id', `sign-${id}`);
    let signatureWidth = width * this.zoomLevel / 100;
    let heightRectangle = height * this.zoomLevel / 100;

    const wrapperLeft = (positionX * this.zoomLevel) / 100;
    const wrapperTop = (positionY * this.zoomLevel) / 100;
    const signZoom = this.zoomLevel / 100;
    let { top, left } = element.getBoundingClientRect();
    const elementId = element.id.replace('text-pdf-layer-', '');
    const widthHeightRatio = this.widthRectangle / this.heightRectangle;
    stampNode.style.position = 'absolute';
    stampNode.style.left = `${wrapperLeft}px`;
    stampNode.style.top = `${wrapperTop}px`;
    stampNode.style.width = `${signatureWidth}px`;
    stampNode.style.height = `${heightRectangle}px`;
    stampNode.style.background = 'rgb(0,0,0,0.2)';
    stampNode.style.zIndex = '1';
    stampNode.style.border = '1px solid #999999';
    stampNode.style.lineHeight = '1.9';
    stampNode.style.color = '#00f';
    stampNode.style.fontFamily = 'Roboto';
    stampNode.style.padding = `${10 * this.zoomLevel / 100}px`;
    stampNode.style.display = 'flex';
    stampNode.style.justifyContent = 'center';
    stampNode.style.flexDirection = 'column';
    stampNode.style.textAlign = 'center';
    stampNode.style.fontWeight = 'bold';
    stampNode.style.minWidth = (this.widthRectangle / 10 * 3) + 'px';
    stampNode.style.minHeight = (this.heightRectangle / 10 * 3) + 'px';
    stampNode.style.userSelect = 'none';
    stampNode.style.cursor = 'move';
    stampNode.textContent = String(name == null ? '' : name);

    // move element
    let baseWrapperLeft;
    let baseWrapperTop;
    let basePageIndex;
    let signIndex;
    let positionIndex;
    let signSelected;
    stampNode.addEventListener('mousedown', (e) => {
      const targetSignId = e.target as Element;
      signId = targetSignId.id.replace('sign-', '');

      this.signaturesFormPositions.forEach((signature, index) => {
        signature.signature.positions.forEach((position, indexPosition) => {
          if (position.signaturePositionId.toString() === signId) {
            signIndex = index;
            positionIndex = indexPosition;
            signSelected = position;
            basePageIndex = parseInt(position.page);
          }
        })
      });
      baseWrapperLeft = stampNode.offsetLeft;
      baseWrapperTop = stampNode.offsetTop;
      stampNode.style.left = (stampNode.offsetLeft - stampNode.offsetWidth / 2 + e.offsetX) + 'px';
      stampNode.style.top = (stampNode.offsetTop - stampNode.offsetHeight / 2 + e.offsetY) + 'px';
      this.renderTextContent(stampNode, name, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: red; cursor: move;`, { notification: { text: this.translateService.instant('messages.click_to_select_sign_position'), style: `position: absolute; top: -${35 * signZoom}px; left: ${(stampNode.offsetWidth / 2 - 150) * signZoom}px; color: red; width: ${300 * signZoom}px;` } });

      document.documentElement.addEventListener('mousemove', doMove);
      document.documentElement.addEventListener('wheel', (wheelEvent) => {
        // stampNode.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
        // stampNode.style.top = `${(wheelEvent.clientY - heightRectangle / 2 - top)}px`;
        const elBounding = element.getBoundingClientRect();
        left = elBounding.left;
        top = elBounding.top;

      })
      document.documentElement.addEventListener('mouseup', stopMove);
    })

    const parentElement = document.getElementById('viewerContainer');

    // wheel element
    parentElement.addEventListener('wheel', (wheelEvent) => {
      // stampNode.style.left = `${(wheelEvent.clientX - signatureWidth / 2 - left)}px`;
      // stampNode.style.top = `${(wheelEvent.clientY - heightRectangle / 2 - top)}px`;
      const elBounding = element.getBoundingClientRect();
      left = elBounding.left;
      top = elBounding.top;

    })

    let goPage
    // Move element sign
    const doMove = (e) => {
      goPage = document.getElementById(`text-pdf-layer-${this.pageIndex}`)

      if (this.pageIndex.toString() !== elementId) {
        const elBounding = goPage.getBoundingClientRect();
        left = elBounding.left;
        top = elBounding.top;
        stampNode.remove();
        goPage.appendChild(stampNode)
      } else {
        const elBounding = element.getBoundingClientRect();
        left = elBounding.left;
        top = elBounding.top;
        stampNode.remove();
        goPage.appendChild(stampNode)
      }
      stampNode.style.left = (e.clientX - stampNode.offsetWidth / 2 - left) + 'px';
      stampNode.style.top = (e.clientY - stampNode.offsetHeight / 2 - top) + 'px';

    }

    // stop move and save position
    const stopMove = (e) => {
      e.stopPropagation();
      if (stampNode.offsetWidth / 2 + stampNode.offsetLeft < 0
        || stampNode.offsetHeight / 2 + stampNode.offsetTop < 0
        || stampNode.offsetWidth / 2 + stampNode.offsetLeft > goPage.offsetWidth
        || stampNode.offsetHeight / 2 + stampNode.offsetTop > goPage.offsetHeight
      ) {
        stampNode.style.left = baseWrapperLeft + 'px';
        stampNode.style.top = baseWrapperTop + 'px';
        this.pageIndex = basePageIndex;
      } else {
        baseWrapperLeft = stampNode.offsetLeft;
        baseWrapperTop = stampNode.offsetTop;
      }
      stampNode.textContent = String(name == null ? '' : name);
      stampNode.appendChild(resizer);
      const signItem = this.signaturesFormPositions[signIndex].signature.positions[positionIndex];
      signItem.x = stampNode.offsetLeft / signZoom;
      signItem.y = stampNode.offsetTop / signZoom;
      signItem.page = this.pageIndex.toString();

      // debugger
      if (this.createContractMohaService.signatureResponse) {
        const responseSign = this.createContractMohaService.signatureResponse[signIndex].positions[positionIndex];
        responseSign.x = stampNode.offsetLeft / signZoom;
        responseSign.y = stampNode.offsetTop / signZoom;
        responseSign.page = this.pageIndex.toString();
        this.createContractMohaService.signatureResponse[signIndex].positions[positionIndex] = responseSign;
      } else {
        const signatureResponses = Object.assign(this.signaturesFormPositions);
        this.createContractMohaService.signatureResponse = [];
        signatureResponses.map(item => {
          const signatureResponse = Object.assign(item.signature);
          this.createContractMohaService.signatureResponse.push(signatureResponse);
        })
      }
      this.createContractMohaService.signatureData.next(this.signaturesFormPositions);

      this.footNote.showSignatureFromData();
      document.documentElement.removeEventListener('mousemove', doMove);
      document.documentElement.removeEventListener('mouseup', stopMove);
    }

    //    resize element
    const resizer = document.createElement('div');
    // resizer.setAttribute('class', 'resize-div-bot-right');
    if(this.stopClose){
      resizer.setAttribute('class', 'resize-div-bot-right');
    }
    resizer.style.setProperty('--zoom', signZoom.toString());
    stampNode.appendChild(resizer);

    let startX, startY;
    let signId;
    let baseWidth;
    let baseHeight;
    resizer.addEventListener('mousedown', (e) => {
      e.stopPropagation();
      startX = e.clientX;
      startY = e.clientY;
      const targetSignId = e.target as Element;
      signId = targetSignId.parentElement.id.replace('sign-', '');

      this.signaturesFormPositions.forEach((signature, index) => {
        signature.signature.positions.forEach((position, indexPosition) => {
          if (position.signaturePositionId.toString() === signId) {
            signIndex = index;
            positionIndex = indexPosition;
            signSelected = position;
          }
        })
      });
      baseWidth = stampNode.offsetWidth;
      baseHeight = stampNode.offsetHeight;
      document.documentElement.addEventListener('mousemove', doDrag);
      document.documentElement.addEventListener('mouseup', stopDrag);

    });

    const rerenderSign = () => {
      stampNode.appendChild(resizer);
      resizer.style.removeProperty('--zoom');
      resizer.style.setProperty('--zoom', (signZoom).toString());
      return;
    }

    const doDrag = (e) => {
      e.stopPropagation();

      signatureWidth = signSelected.width * signZoom;
      heightRectangle = signSelected.height * signZoom;

      stampNode.style.width = (signatureWidth + e.clientX - startX) + 'px';
      stampNode.style.height = (signatureWidth + e.clientY - startY) + 'px';
      stampNode.style.maxWidth = (elWidth - wrapperLeft) + 'px';
      stampNode.style.maxHeight = (elHeight - wrapperTop) + 'px';
      let widthHeightRatio_Drag = stampNode.offsetWidth / stampNode.offsetHeight;

      if (widthHeightRatio !== widthHeightRatio_Drag) {
        stampNode.style.height = (stampNode.offsetWidth / widthHeightRatio) + 'px';
        stampNode.style.width = (stampNode.offsetHeight * widthHeightRatio) + 'px';
      }
    }

    const stopDrag = (e) => {
      e.stopPropagation();
      if (stampNode.offsetWidth / 2 + wrapperLeft < 0 || stampNode.offsetHeight / 2 + wrapperTop < 0) {
        stampNode.style.width = baseWidth + 'px';
        stampNode.style.height = baseHeight + 'px';
      } else {
        baseWidth = stampNode.offsetWidth;
        baseHeight = stampNode.offsetHeight;
      }
      const signItem = this.signaturesFormPositions[signIndex].signature.positions[positionIndex];
      signItem.width = stampNode.offsetWidth / signZoom;
      signItem.height = stampNode.offsetHeight / signZoom;

      if (this.createContractMohaService.signatureResponse) {
        const responseSign = this.createContractMohaService.signatureResponse[signIndex].positions[positionIndex];
        responseSign.x = stampNode.offsetLeft / signZoom;
        responseSign.y = stampNode.offsetTop / signZoom;
        responseSign.page = this.pageIndex.toString();
        this.createContractMohaService.signatureResponse[signIndex].positions[positionIndex] = responseSign;
      } else {
        const signatureResponses = Object.assign(this.signaturesFormPositions);
        this.createContractMohaService.signatureResponse = [];
        signatureResponses.map(item => {
          const signatureResponse = Object.assign(item.signature);
          this.createContractMohaService.signatureResponse.push(signatureResponse);
        });
      }
      this.createContractMohaService.signatureData.next(this.signaturesFormPositions);

      // stampNode.appendChild(resizer);
      document.documentElement.removeEventListener('mousemove', doDrag);
      document.documentElement.removeEventListener('mouseup', stopDrag);
    };
    return stampNode;
  }

  showFramesNotification(signSelected, position = null, isContractCodeConfig = false) {
    const nodeOther = document.getElementById('show-frames-notification');
    if (nodeOther) {
      nodeOther.remove();
    }
    const element: any = document.getElementById(`text-pdf-layer-${signSelected.pageIndex}-${this.activeFile}`);
    const signatureWidth = signSelected.widthRectangle * this.zoomLevel / 100;
    const heightRectangle = signSelected.heightRectangle * this.zoomLevel / 100;
    const newTop = position.top ? position.top : 0
    const newLeft = position.left ? position.left : 0
    const stampNode = document.createElement('div');
    const signZoom = this.zoomLevel / 100;
    stampNode.setAttribute('id', 'show-frames-notification');
    // keo chan ky
    if (!isContractCodeConfig) {
      this.getOffClose(this.signSelected);
     if(this.signSelected.row_number && this.stopClose){
       this.renderTextContent(stampNode, `${this.message.getMessage('signature')} ${this.signSelected && this.signSelected.name ? this.signSelected.name : ''} ${this.message.getMessage('number_sign')} ${this.signSelected.row_number}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: red; cursor: move;`, { notification: { text: this.translateService.instant('messages.click_to_select_sign_position'), style: `position: absolute; top: -${35 * signZoom}px; left: ${(signSelected.widthRectangle / 2 - 150) * signZoom}px; color: red; width: ${300 * signZoom}px;` } });
     }
     else{
       this.renderTextContent(stampNode, `${this.message.getMessage('signature')} ${this.signSelected && this.signSelected.name ? this.signSelected.name : ''}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: red; cursor: move;`, { notification: { text: this.translateService.instant('messages.click_to_select_sign_position'), style: `position: absolute; top: -${35 * signZoom}px; left: ${(signSelected.widthRectangle / 2 - 150) * signZoom}px; color: red; width: ${300 * signZoom}px;` } });
     }
    } else {
      // stampNode.style.whiteSpace = 'nowrap';
      stampNode.style.wordBreak = 'break-word';
      if (this.documentCodeNull && !this.isOnAutoNumber) {
        this.renderTextContent(stampNode, this.isOnAutoNumber ? this.configAutoNumber : this.message.getMessage('headertable.doc_code_required'), `font-size: ${(signSelected.fontSize ? signSelected.fontSize : 12) * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; align-items: start; text-align: left; height: 100%; cursor: move;`, { contentClass: 'text-danger' });
      } else {
        this.renderTextContent(stampNode, this.isOnAutoNumber ? this.configAutoNumber : this.document.code, `font-size: ${(signSelected.fontSize ? signSelected.fontSize : 12) * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; align-items: start; text-align: left; height: 100%; color: #00f; cursor: move;`);
      }

      //stampNode.style.minWidth = (300 / 10 * 3 * signZoom) + 'px';
      stampNode.style.minHeight = (136 / 10 * 3 * signZoom) + 'px';
      // stampNode.style.minWidth ='fit-content';
      stampNode.style.wordBreak = 'break-word';
    }
    stampNode.style.position = 'absolute';
    stampNode.style.background = 'rgb(0,0,0,0.2)';
    stampNode.style.left = `${newLeft}px`;
    stampNode.style.top = `${newTop}px`;
    stampNode.style.width = `${signatureWidth}px`;
    stampNode.style.height = `${heightRectangle}px`;
    stampNode.style.zIndex = '1';
    stampNode.style.border = '1px solid #999999';
    stampNode.style.lineHeight = '1.9';
    if (this.documentCodeNull && !this.isOnAutoNumber) {
      stampNode.style.color = 'red';
    } else {
      stampNode.style.color = '#00f';
    };
    if (signSelected.fontSize) {
      stampNode.style.fontSize = signSelected.fontSize;
    };
    if (signSelected.fontFamily) {
      stampNode.style.fontFamily = signSelected.fontFamily;
    } else {
      stampNode.style.fontFamily = 'Roboto';
    };
    if (signSelected.fontStyle && signSelected.fontStyle.includes('bold')) {
      stampNode.style.fontWeight = 'bold';
    }
    if (signSelected.fontStyle && signSelected.fontStyle.includes('italic')) {
      stampNode.style.fontStyle = 'italic';
    }
    if (signSelected.fontStyle && signSelected.fontStyle.includes('underline')) {
      stampNode.style.textDecoration = 'underline';
    }
    stampNode.style.padding = `${10 * signZoom}px`;
    stampNode.className = 'no-user-select';
    this.stampWrapper = stampNode;
    element.appendChild(stampNode);
  }

  onChangeZoom(event: any) {
    this.zoomLevel = event * 100;
  }

  checkHaveSign(item: any, signData) {
    const files = this.createContractMohaService.fileUploadArray.getValue();
    let id;
    let check;
    let idSign = signData.contractSignId || signData.idNumber
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      id = file.id ? file.id : null;
    }
    if (item.enterpriseId) {
      check = this.listSign.find(sign =>
        (sign.enterpriseId === item.enterpriseId || sign.customerId === item.customerId) && sign.userId === item.userId && sign.fileId === id && (idSign === sign.contractSignId || idSign === sign.idNumber)
       );
       return check ? true : false;
    }
    check = this.listSign.find(sign =>
      sign.customerId === item.customerId && sign.userId === item.userId && sign.fileId === id && (idSign === sign.contractSignId || idSign === sign.idNumber)
    );
    return check ? true : false;
  }

  index = 1;

  //Thêm khung ký tên doanh nghiệp
  addSign(item: any) {
    // Lay so thu tu chan ky
    const idNumber = uuid.v4();
    // if(item.customerId){
    //   idNumber = this.listSign.filter(res=> res.customerId == item.customerId).length + 1
    // } else {
    //   idNumber = this.listSign.filter(res=> res.enterpriseId == item.enterpriseId).length + 1
    // }

    if (!this.pdfSrc) {
      if (!this.toastr.findDuplicate(this.message.getMessage('messages.error_contract'), true, true)) {
        this.toastr.error(this.message.getMessage('messages.error_contract'));
      }
      const listBtn = document.querySelectorAll("button");
      listBtn.forEach((btn) => {
        if (btn.className.includes('mat-stroked-button-create-document')) {
          btn.classList.add("btn_glowing");
        }
      });
      setTimeout(() => {
        listBtn.forEach((btn) => {
          btn.classList.remove("btn_glowing");
        });
      }, 5000);
      return;
    }
    // console.log(`text-pdf-layer-${this.pageIndex}-${this.activeFile}`);
    if (!document.getElementById(`text-pdf-layer-${this.pageIndex}-${this.activeFile}`)) {
      setTimeout(() => {
        this.addSign(item);
      }, 100);
      return;
    }
    this.returnToPrevPosition();
    if (!this.isSelectPosition) {
      const itemNew = JSON.parse(JSON.stringify(item));
      itemNew.idNumber = idNumber
      itemNew.row_number = 1
      const element: any = document.getElementById(`text-pdf-layer-${this.pageIndex}-${this.activeFile}`);
      const view: any = document.getElementById('viewerContainer');
      const elementBounding = element.getBoundingClientRect();
      const viewBounding = view.getBoundingClientRect();
      const offsetParent = element.offsetParent.dataset;
      const { pageNumber } = offsetParent;
      let signatureWidth = this.widthRectangle * this.zoomLevel / 100;
      let heightRectangle = this.heightRectangle * this.zoomLevel / 100;
      let signZoom = this.zoomLevel / 100;
      const widthHeightRatio = this.widthRectangle / this.heightRectangle;
      const wrapperLeft = 0;
      let wrapperTop = 0;
      if (viewBounding.y - elementBounding.y > heightRectangle) {
        wrapperTop = viewBounding.y - elementBounding.y;
      }
      const newDiv = document.createElement('div');
      // Sua Id chu ky

      newDiv.setAttribute('id', `${idNumber}-sign-${itemNew.enterpriseId || itemNew.customerId }-approver-${itemNew.userId}`);
      newDiv.style.left = `${wrapperLeft}px`;
      newDiv.style.top = `${wrapperTop}px`;
      newDiv.style.width = `${signatureWidth}px`;
      newDiv.style.height = `${heightRectangle}px`;
      newDiv.style.background = 'rgb(0,0,0,0.2)';
      newDiv.style.zIndex = '1';
      newDiv.style.border = '1px solid #999999';
      newDiv.style.lineHeight = '1.9';
      newDiv.style.color = '#00f';
      newDiv.style.fontFamily = 'Roboto';
      newDiv.style.padding = `${10 * signZoom}px`;
      newDiv.style.position = 'absolute';
      newDiv.style.minWidth = (300 / 10 * 3 * signZoom) + 'px';
      newDiv.style.minHeight = (136 / 10 * 3 * signZoom) + 'px';
      this.getOffClose(itemNew);
      if(itemNew.row_number && this.stopClose){
        this.renderTextContent(newDiv, `${this.message.getMessage('signature')} ${itemNew.name} ${this.message.getMessage('number_sign')} ${itemNew.row_number}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
      }else {
        this.renderTextContent(newDiv, `${this.message.getMessage('signature')} ${itemNew.name}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`);
      }
      // <div class="resize-div-bot-right" style="--zoom: ${this.zoomLevel}"></div>
      newDiv.className = 'no-user-select';
      const zoomLevel = this.zoomLevel;
      itemNew.stampPositionLeft = 0;
      itemNew.stampPositionTop = 0;
      itemNew.positionX = 100 * wrapperLeft / zoomLevel;
      itemNew.positionY = 100 * wrapperTop / zoomLevel;
      itemNew.pageIndex = this.pageIndex;
      itemNew.zoom = this.zoomLevel / 100;
      itemNew.pdfSrc = this.pdfSrc;
      itemNew.pageNumber = pageNumber;
      itemNew.widthRectangle = this.widthRectangle;
      itemNew.heightRectangle = this.heightRectangle;
      const files = this.createContractMohaService.fileUploadArray.getValue();
      let find;
      if (files && files.length && files[this.activeFile]) {
        const file = files[this.activeFile] as any;
        itemNew.fileId = file.id ? file.id : null;
        // Them nhieu chan ky
        // if (file) {
        //   if (item.enterpriseId) {
        //     find = this.listSign.find(sign => sign.fileId === file.id && sign.enterpriseId === item.enterpriseId && sign.userId === item.userId);
        //   } else {
        //     find = this.listSign.find(sign => sign.fileId === file.id &&  sign.customerId === item.customerId && sign.userId === item.userId);
        //   }
        // }
      }
      if (!find) {
        const resizer = document.createElement('div');
        // resizer.setAttribute('class', 'resize-div-bot-right');
        if(this.stopClose){
          resizer.setAttribute('class', 'resize-div-bot-right');
        }
        resizer.style.setProperty('--zoom', signZoom.toString());
        newDiv.appendChild(resizer);
        element.appendChild(newDiv);

        let startX, startY;
        let signId;
        let userId;
        let indexApprover;
        let idNumber;
        let signUuid;
        resizer.addEventListener('mousedown', (e) => {
          e.stopPropagation();
          startX = e.clientX;
          startY = e.clientY;
          document.documentElement.addEventListener('mousemove', doDrag);
          document.documentElement.addEventListener('mouseup', stopDrag);
          const targetSignId = e.target as Element;


          indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
          const indexSign = targetSignId.parentElement.id.indexOf('-sign-');
          signId = targetSignId.parentElement.id.slice(indexSign + 6, indexApprover);
          userId = targetSignId.parentElement.id.slice(indexApprover + 10);
          signUuid = targetSignId.parentElement.id.slice(0, indexSign);

        });

        // const signSelected = this.listSign.filter(item => item.enterpriseId === signId);

        let baseWidth = newDiv.offsetWidth;
        let baseHeight = newDiv.offsetHeight;
        const rerenderSign = () => {
          const signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId) && ((signUuid === item.idNumber && item.idNumber) || (signUuid === item.contractSignId && item.contractSignId)));
          this.getOffClose(signSelected[0]);
          if(signSelected[0].row_number && this.stopClose){
            this.renderTextContent(newDiv, `${this.message.getMessage('signature')} ${signSelected[0].name} ${this.message.getMessage('number_sign')} ${signSelected[0].row_number}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
          }else {
            this.renderTextContent(newDiv, `${this.message.getMessage('signature')} ${signSelected[0].name}`, `font-size: ${16 * signZoom}px; display: flex; flex-direction: column; justify-content: center; text-align: center; height: 100%; color: #00f; cursor: move;`);
          }
          newDiv.appendChild(resizer);
          resizer.style.removeProperty('--zoom');
          resizer.style.setProperty('--zoom', (signZoom).toString());
          return;
        }

        const doDrag = (e) => {
          e.stopPropagation();
          const signSelected = this.listSign.filter(item => (item.enterpriseId === signId || item.customerId === signId) && ((signUuid === item.idNumber && item.idNumber) || (signUuid === item.contractSignId && item.contractSignId)));
          signatureWidth = signSelected[0].widthRectangle * this.zoomLevel / 100;
          heightRectangle = signSelected[0].heightRectangle * this.zoomLevel / 100;

          newDiv.style.width = (signatureWidth + e.clientX - startX) + 'px';
          newDiv.style.height = (signatureWidth + e.clientY - startY) + 'px';
          newDiv.style.maxWidth = (element.offsetWidth - wrapperLeft) + 'px';
          newDiv.style.maxHeight = (element.offsetHeight - wrapperTop) + 'px';
          let widthHeightRatio_Drag = newDiv.offsetWidth / newDiv.offsetHeight;
          if (widthHeightRatio !== widthHeightRatio_Drag) {
            newDiv.style.height = (newDiv.offsetWidth / widthHeightRatio) + 'px';
            newDiv.style.width = (newDiv.offsetHeight * widthHeightRatio) + 'px';
          }
          rerenderSign();
        }

        const stopDrag = (e) => {
          e.stopPropagation();
          if (newDiv.offsetWidth / 2 + wrapperLeft < 0 || newDiv.offsetHeight / 2 + wrapperTop < 0) {
            newDiv.style.width = baseWidth + 'px';
            newDiv.style.height = baseHeight + 'px';
          } else {
            baseWidth = newDiv.offsetWidth;
            baseHeight = newDiv.offsetHeight;
          }
          rerenderSign();

          this.listSign.forEach(item => {
            if ((item.enterpriseId === signId || item.customerId === signId) && ((signUuid === item.idNumber && item.idNumber) || (signUuid === item.contractSignId && item.contractSignId))) {
              item.widthRectangle = newDiv.offsetWidth * 100 / this.zoomLevel;
              item.heightRectangle = newDiv.offsetHeight * 100 / this.zoomLevel;
            }
          });
          this.createContractMohaService.signPositions.next(this.listSign);
          document.documentElement.removeEventListener('mousemove', doDrag);
          document.documentElement.removeEventListener('mouseup', stopDrag);
        }

        this.listSign.push(itemNew);
        this.createContractMohaService.signPositions.next(this.listSign);
        this.changeDataToTable()
      }
    }
  }

  deleteSign(enterpriseId: string, userId: string, signUuid) {
    this.returnToPrevPosition();
    const files = this.createContractMohaService.fileUploadArray.getValue();
    let id;
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      id = file.id ? file.id : null;
    }
    if (userId === undefined || userId === '' || userId === null || userId === 'undefined') {
      // la khach hang ca nnhan
      this.listSign = this.listSign.filter(sign => {
        return (sign.enterpriseId !== enterpriseId && sign.customerId !== enterpriseId && sign.fileId === id) || sign.fileId !== id ||
        ((sign.idNumber && signUuid != sign.idNumber) || (signUuid != sign.contractSignId && sign.contractSignId));
      });
    } else {
      this.listSign = this.listSign.filter(sign => {
        return (sign.userId !== userId && sign.fileId === id) || sign.fileId !== id ||  ((sign.idNumber && signUuid != sign.idNumber) || (signUuid != sign.contractSignId && sign.contractSignId));
      });
    }
    this.createContractMohaService.signPositions.next(this.listSign);
    const nodeOther = document.getElementById(`${signUuid}-sign-${enterpriseId}-approver-${userId}`);

    if (nodeOther) {
      nodeOther.remove();
    }
    this.changeDataToTable()
  }

  deleteSignature(idSignature: string) {
    this.returnToPrevPositionSignContract();
    const files = this.createContractMohaService.fileUploadArray.getValue();
    let id;
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      id = file.id ? file.id : null;
    }
    this.listSignature = this.listSignature.filter(sign => sign.id != idSignature);
    this.listSignatureTable = this.listSignatureTable.filter(sign => sign.id != idSignature);
    this.createContractMohaService.contractCodePositions.next(this.listSignature);
    if (this.listSignatureTable && this.listSignatureTable.length) {
      this.createContractMohaService.listSignatureTable.next(this.listSignatureTable);
    }
    let listHeaderTabs = [];
    this.listSignatureHeadRows.forEach(headerTitle => {
      this.listSignatureTable.forEach(item => {
        if ((item.fileName ? item.fileName : this.getDecodeUri(item.fileId)) == headerTitle) {
          listHeaderTabs.push({ headerTitle });
        }
      })
    })

    //for list chi lay header co trong list
    this.listSignatureHeadRows = this.listSignatureHeadRows.filter(item => listHeaderTabs.map(x => x.headerTitle).includes(item));
    const nodeOther = document.getElementById(idSignature);
    if (nodeOther) {
      nodeOther.remove();
    }
  }

  goToPage(enterpriseId: string, userId: string, signData) {
    this.returnToPrevPosition();
    const files = this.createContractMohaService.fileUploadArray.getValue();
    let id;
    if (files && files.length && files[this.activeFile]) {
      const file = files[this.activeFile] as any;
      id = file.id ? file.id : null;
    }
    let idSign = signData.contractSignId || signData.idNumber
    const node = document.getElementById(`${idSign}-sign-${enterpriseId}-approver-${userId}`);
    const sign = this.listSign.find(sign => (sign.enterpriseId === enterpriseId || sign.customerId === enterpriseId) && sign.userId === userId && sign.fileId === id);
    this.pageIndex = sign ? sign.pageIndex : 1;
    if (node) {
      setTimeout(() => {
        node.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
      });
    } else {
      this.signNeedShow = sign.enterpriseId || sign.customerId;
      this.signApproverNeedShow = sign.userId;
    }
  }



  returnToPrevPositionSignContract() {
    if (Object.keys(this.signatureSelected || {}).length) {
      const position = this.signatureSelected;
      const element = document.getElementById(`text-pdf-layer-${position.pageIndex}-${this.activeFile}`);
      const x = position.positionX;
      const y = position.positionY;
      const _width = position.widthRectangle;
      const _height = position.heightRectangle;
      const name = this.isOnAutoNumber ? this.configAutoNumber : this.document.code; //add configAutoNumber or code
      const id = position.id;
      const fontSize = position.fontSize;
      const fontFamily = position.fontFamily;
      const fontStyle = position.fontStyle;
      const elWidth = element.offsetWidth;
      const elHeight = element.offsetHeight;

      const htmlNode = this.getStampWrapper(x, y, _width, _height, name, id, elWidth, elHeight, '', fontSize, fontFamily, fontStyle, true, (position.contractSignId || position.idNumber), position.row_number);
      element.appendChild(htmlNode);
      this.signatureSelected = null;
      this.isSelectPosition = false;
      document.body.style.userSelect = 'none';
    }
  }

  returnToPrevPosition() {
    if (Object.keys(this.signSelected || {}).length) {
      const position = this.signSelected;
      const element = document.getElementById(`text-pdf-layer-${position.pageIndex}-${this.activeFile}`);
      const x = position.positionX;
      const y = position.positionY;
      const _width = position.widthRectangle;
      const _height = position.heightRectangle;
      const name = position.name;
      const id = position.enterpriseId || position.customerId;
      const userId = position.userId;
      const elWidth = element.offsetWidth;
      const elHeight = element.offsetHeight;
      const htmlNode = this.getStampWrapper(x, y, _width, _height, name, id, elWidth, elHeight, userId, null, null, [], false, (this.signSelected.idNumber || this.signSelected.contractSignId), this.signSelected.row_number);
      element.appendChild(htmlNode);
      this.signSelected = null;
      this.isSelectPosition = false;
      document.body.style.userSelect = 'none';
    }
  }

  renderSignViewWhenDataChange() {
    const users = this.createContractMohaService.recordsPartySign.getValue();
    const approver = this.createContractMohaService.recordsUserPerformSign.getValue();
    if (!this.signaturesFormPositions || !this.signaturesFormPositions.length) {
      return;
    }
    this.signaturesFormPositions.forEach(sign => {
      if (sign.signature && sign.signature.positions) {
        sign.signature.positions.forEach(item => {
          const element = document.getElementById(`text-pdf-layer-${item.page}`);
          if (element) {
            let name = null;
            if (sign.customerId && sign.signature.object === 'CUSTOMER') {
              const customer = users.find(user => user.customerId === sign.customerId);
              if (customer && customer.name) {
                name = customer.name;
              } else {
                name = sign.signature.name;
              }
            } else if (sign.userId && sign.signature.object === 'ENTERPRISEAPPROVER') {
              const approve = approver.find(user => user.userId === sign.userId);
              if (approve && approve.name && approve.isSignDigitalCertificate && approve.signConfig.showImage) {
                name = approve.name;
              } else {
                name = sign.signature.name;
              }
            } else {
              if (sign.signature.object === 'CUSTOMER') {
                name = sign.signature.name;
              } else if (sign.signature.object === 'ENTERPRISEAPPROVER') {
                name = sign.signature.name;
              } else {
                const createSide = users.find(user => user.isCreatedSide);
                const userPerformSign = this.createContractMohaService.recordsUserPerformSign.getValue();
                const userSign = userPerformSign.find(user => user.role === '1');
                if (createSide && userSign) {
                  name = userSign.name;
                } else {
                  name = this.message.getMessage('signature_tab.create_side');
                }
              }
            }
            const id = item.signaturePositionId;
            const signBox = document.getElementById(`sign-${id}`);
            if (signBox) {
              signBox.remove();
            }
            const x = item.x;
            const y = item.y;
            const _width = item.width;
            const _height = item.height;
            const elWidth = element.offsetWidth;
            const elHeight = element.offsetHeight;
            const htmlNode = this.getStampWrapperForm(x, y, _width, _height, name, id, elWidth, elHeight, element);
            element.appendChild(htmlNode);
          }
        })
      }
    })
  }

  async genSignatureData() {
    const body: any = {
      code: this.createContractMohaService.key
    }

    // console.log("key", this.createContractMohaService.key);
    const res = await this.documentTemplateService.getSignaturePosition(body, this.createContractMohaService.selectedTemplate.getValue().id).toPromise();
    this.renderSignOnce = 1
    this.blockUI.reset();
    this.blockUI.start('');
    if (!res || !res.data) {
      this.blockUI.stop();
      return;
    }
    // if (!this.createContractMohaService.signatureData.getValue()) {
    //   this.createContractMohaService.signatureResponse = res.data;
    // }
    this.createContractMohaService.signatureResponse = res.data;


    if (!this.createContractMohaService.signatureData.getValue() || (this.createContractMohaService.signatureData.getValue() && this.handsontableService.dirty.value)) {
      const data = res.data.map(item => {
        const signature: any = { signature: item };
        return signature;
      });
      this.signaturesFormPositions = this.genSignature(data);
      // debugger
      this.createContractMohaService.signatureResponse = res.data;
      this.createContractMohaService.signatureData.next(this.signaturesFormPositions);
    } else {
      this.signaturesFormPositions.map(sign => {
        if (sign.signature && sign.signature.positions) {
          const page = [];
          const signature = res.data.find(item => item.signatureId === sign.signature.signatureId);
          if (signature && signature.positions) {
            sign.signature.positions.map(position => {
              const positionData = sign.signature.positions.find(pos => pos.signaturePositionId === position.signaturePositionId);
              if (positionData) {
                position.x = positionData.x;
                position.y = positionData.y;
                position.page = positionData.page ? positionData.page : null;
              }
              if (position.page && !page.includes(position.page)) {
                page.push(position.page);
              }
            })
          }
          sign.signature.page = page.join(', ');
        }
      })
    }
    setTimeout(() => {
      this.blockUI.stop();
    })
  }

  genSignature(signature: any) {
    const users = this.createContractMohaService.recordsPartySign.getValue();
    const listUsers = this.createContractMohaService.recordsUserPerformSign.getValue();
    const enterprise = users.find(item => item.isCreatedSide);
    const customers = users.filter(user => {
      return !user.isCreatedSide
    });
    const approver = listUsers.filter(item => {
      return item.role === '2' && item.isSignDigitalCertificate && item.signConfig.showImage;
    })
    let indexCustomer = 0;
    let indexApprover = 0;
    const data = signature.map(item => {
      if (item.signature) {
        const page = [];
        if (item.signature.positions) {
          item.signature.positions.forEach(pos => {
            if (pos.page && !page.includes(pos.page)) {
              page.push(pos.page);
            }
          });
        }
        item.signature.page = page.join(', ');
        if (item.signature.object && item.signature.object === 'ENTERPRISE') {
          item.customerId = enterprise && (enterprise.enterpriseId || enterprise.customerId ) ? (enterprise.enterpriseId || enterprise.customerId) : localStorage.getItem('enterpriseId');
        } else if (item.signature.object && item.signature.object === 'ENTERPRISEAPPROVER') {
          item.userId = approver && approver[indexApprover] && approver[indexApprover].userId ? approver[indexApprover].userId : null;
          indexApprover++;
        } else {
          item.customerId = customers && customers[indexCustomer] && customers[indexCustomer].customerId ? customers[indexCustomer].customerId : null;
          indexCustomer++;
        }
      }
      return item;
    });
    return data;
  }

  changeFile(path: string, index: number) {
    this.selectedFileSign = index
    this.pageIndex = 1;
    this.activeFile = index;
    if (this.listPdfSrc) {
      // this.pdfSrc = this.fileSrc[index];
      this.pdfSrc = this.listPdfSrc[path];
    }
  }

  changeFileAddContractCode(event: any, type?: string) {
    this.documentCodeNull = (this.document.code.length == 0);
    let idx = 0;
    if (type && type == 'selectFile') {
      idx = event.value;
      this.selectedNumberPage = 1;
    } else {
      if (type == 'goToPage') {
        this.selectedNumberPage = null;
      }
      idx = event;
    }

    this.pageIndex = 1;
    this.document.mainContractAttachments.forEach((file, index) => {
      if (file.fileName == this.fileUploads[idx].name) {
        this.activeFile = index;
      }
    });
    //this.activeFile = idx;
    const file = this.createContractMohaService.fileUploadSrc.getValue();
    this.selectFile = this.fileUploads[idx];
    if (file.length) {
      this.pdfSrc = file[idx];
      this.isCheckFile = false;
    }

  }


  //doi font chu
  //doi font size

  // them chan ky vao trang
  addSignature(item) {
    const arr = document.querySelectorAll('.page')
    if (arr) {
      setTimeout(() => {
        arr.item(item.page - 1).scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" })
      });
    }
    if (!this.pdfSrc) {
      if (!this.toastr.findDuplicate(this.message.getMessage('messages.error_contract'), true, true)) {
        this.toastr.error(this.message.getMessage('messages.error_contract'));
      }
      const listBtn = document.querySelectorAll("button");
      listBtn.forEach((btn) => {
        if (btn.className.includes('mat-stroked-button-create-document')) {
          btn.classList.add("btn_glowing");
        }
      });
      setTimeout(() => {
        listBtn.forEach((btn) => {
          btn.classList.remove("btn_glowing");
        });
      }, 5000);
      return;
    }

    if (!document.getElementById(`text-pdf-layer-${this.pageIndex}-${this.activeFile}`)) {
      setTimeout(() => {
        this.addSignature(item);
      }, 100);
      return;
    }

    this.returnToPrevPositionSignContract();
    if (!this.isSelectPosition) {
      const itemNew = JSON.parse(JSON.stringify(item));
      const element: any = document.getElementById(`text-pdf-layer-${item.page}-${this.activeFile}`);
      const view: any = document.getElementById('viewerContainer');
      const elementBounding = element.getBoundingClientRect();
      const viewBounding = view.getBoundingClientRect();
      const offsetParent = element.offsetParent.dataset;
      const { pageNumber } = offsetParent;
      let signatureWidth = this.widthRectangleSignature * this.zoomLevel / 100;
      let signatureHeight = this.heightRectangleSignature * this.zoomLevel / 100;
      let signZoom = this.zoomLevel / 100;
      const wrapperLeft = 0;
      let wrapperTop = 0;
      if (viewBounding.y - elementBounding.y > signatureHeight) {
        wrapperTop = viewBounding.y - elementBounding.y;
      }
      const newDiv = document.createElement('div');
      newDiv.setAttribute('id', `${itemNew.id}`);//tao div co id
      newDiv.style.left = `${wrapperLeft}px`;
      newDiv.style.top = `${wrapperTop}px`;
      newDiv.style.width = `${signatureWidth}px`;
      newDiv.style.height = `${signatureHeight}px`;
      newDiv.style.background = 'rgb(0,0,0,0.2)';
      newDiv.style.zIndex = '1';
      newDiv.style.border = '1px solid #999999';
      newDiv.style.lineHeight = '1.9';
      if (this.documentCodeNull && !this.isOnAutoNumber) {
        newDiv.style.color = 'red';
      } else {
        newDiv.style.color = '#00f';
      }
      newDiv.style.fontFamily = 'Roboto';
      newDiv.style.padding = `${10 * signZoom}px`;
      newDiv.style.position = 'absolute';
      newDiv.style.fontSize = '12px';
      newDiv.style.minWidth = (300 / 10 * 3 * signZoom) + 'px';
      newDiv.style.minHeight = (136 / 10 * 3 * signZoom) + 'px';
      // newDiv.style.whiteSpace = 'nowrap';
      // newDiv.style.minWidth ='fit-content';
      newDiv.style.wordBreak = 'break-word';
      if (this.documentCodeNull && !this.isOnAutoNumber) {
        this.renderTextContent(newDiv, this.isOnAutoNumber ? this.configAutoNumber : this.message.getMessage('headertable.doc_code_required'), `font-size: ${12 * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; cursor: move;`, { closeIconSize: 30 * signZoom, contentClass: 'text-danger' });
      } else {
        this.renderTextContent(newDiv, this.isOnAutoNumber ? this.configAutoNumber : this.document.code, `font-size: ${12 * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
      }

      // <div class="resize-div-bot-right" style="--zoom: ${this.zoomLevel}"></div>
      newDiv.className = 'no-user-select';
      const zoomLevel = this.zoomLevel;
      itemNew.stampPositionLeft = 0;
      itemNew.stampPositionTop = 0;
      itemNew.positionX = 100 * wrapperLeft / zoomLevel;
      itemNew.positionY = 100 * wrapperTop / zoomLevel;
      itemNew.pageIndex = item.page;
      itemNew.zoom = this.zoomLevel / 100;
      itemNew.pdfSrc = this.pdfSrc;
      itemNew.pageNumber = item.page;
      itemNew.widthRectangle = this.widthRectangleSignature;
      itemNew.heightRectangle = this.heightRectangleSignature;
      const files = this.createContractMohaService.fileUploadArray.getValue();
      let find;
      if (files && files.length && files[this.activeFile]) {
        const file = files[this.activeFile] as any;
        itemNew.fileId = file.id ? file.id : null;
        if (file) {
          //tim item theo fieldId va id
          find = this.listSignature.find(sign => sign.fileId === file.id && sign.id === item.id);
        }
      }
      if (!find) {
        const resizer = document.createElement('div');
        // resizer.setAttribute('class', 'resize-div-bot-right');
        if(this.stopClose){
          resizer.setAttribute('class', 'resize-div-bot-right');
        }
        resizer.style.setProperty('--zoom', signZoom.toString());
        newDiv.appendChild(resizer);
        element.appendChild(newDiv);

        let startX, startY;
        let id;
        let signId;
        let userId;
        let indexApprover;
        resizer.addEventListener('mousedown', (e) => {
          e.stopPropagation();
          startX = e.clientX;
          startY = e.clientY;
          document.documentElement.addEventListener('mousemove', doDrag);
          document.documentElement.addEventListener('mouseup', stopDrag);
          const targetSignId = e.target as Element;
          indexApprover = targetSignId.parentElement.id.indexOf('-approver-');
          id = targetSignId.parentElement.id;
          //signId = targetSignId.parentElement.id.slice(5, indexApprover);
          //userId = targetSignId.parentElement.id.slice(indexApprover + 10);
        });

        // const signSelected = this.listSign.filter(item => item.enterpriseId === signId);

        let baseWidth = newDiv.offsetWidth;
        let baseHeight = newDiv.offsetHeight;

        const rerenderSign = () => {
          //tim theo id roi render lai
          const signSelected = this.listSignature.filter(item => item.id === id);
          if (this.documentCodeNull && !this.isOnAutoNumber) {
            this.renderTextContent(newDiv, this.isOnAutoNumber ? this.configAutoNumber : this.message.getMessage('headertable.doc_code_required'), `font-size: ${12 * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; cursor: move;`, { closeIconSize: 30 * signZoom, contentClass: 'text-danger' });
          } else {
            this.renderTextContent(newDiv, this.isOnAutoNumber ? this.configAutoNumber : this.document.code, `font-size: ${signSelected[0].fontSize * (4 / 3) * signZoom}px; display: flex; flex-direction: column; justify-content: start; text-align: left; height: 100%; color: #00f; cursor: move;`, { closeIconSize: 30 * signZoom });
          }

          newDiv.appendChild(resizer);
          resizer.style.removeProperty('--zoom');
          resizer.style.setProperty('--zoom', (signZoom).toString());
          return;
        }

        const doDrag = (e) => {
          this.currentNodeSelected = newDiv;
          e.stopPropagation();
          //tim chu ky do roi set thong so
          const signSelected = this.listSignature.filter(item => item.id == id);
          signatureWidth = signSelected[0].widthRectangle * this.zoomLevel / 100;
          signatureHeight = signSelected[0].heightRectangle * this.zoomLevel / 100;
          newDiv.style.width = (signatureWidth + e.clientX - startX) + 'px';
          newDiv.style.height = (signatureHeight + e.clientY - startY) + 'px';
          newDiv.style.maxWidth = (element.offsetWidth - wrapperLeft) + 'px';
          newDiv.style.maxHeight = (element.offsetHeight - wrapperTop) + 'px';
          rerenderSign();
        }

        const stopDrag = (e) => {
          e.stopPropagation();
          if (newDiv.offsetWidth / 2 + wrapperLeft < 0 || newDiv.offsetHeight / 2 + wrapperTop < 0) {
            newDiv.style.width = baseWidth + 'px';
            newDiv.style.height = baseHeight + 'px';
          } else {
            baseWidth = newDiv.offsetWidth;
            baseHeight = newDiv.offsetHeight;
          }
          rerenderSign();

          this.listSignature.forEach(item => {
            if (item.id === id) {
              item.widthRectangle = newDiv.offsetWidth * 100 / this.zoomLevel;
              item.heightRectangle = newDiv.offsetHeight * 100 / this.zoomLevel;
            }
          });
          this.createContractMohaService.contractCodePositions.next(this.listSignature);
          document.documentElement.removeEventListener('mousemove', doDrag);
          document.documentElement.removeEventListener('mouseup', stopDrag);
        }

        this.listSignature.push(itemNew);
        this.createContractMohaService.contractCodePositions.next(this.listSignature);
      }
    }
  }

  onPagesLoaded(pagecount: PagesLoadedEvent): void {
    this.totalPage = pagecount.pagesCount;

  }

  addListSignHeadRows(fileName) {
    if (!this.listSignatureHeadRows.find(s => s === fileName)) {
      this.listSignatureHeadRows.push(fileName);
    }
  }
  getDecodeUri(item) {
    return decodeURI(item);
  }

  changeFileAddSign(event: any, type?: string){
    this.documentCodeNull = (this.document.code.length == 0);
    let idx = 0;
    if (type && type == 'selectFileSign') {
      idx = event.value;
      this.selectedNumberPage = 1;
    } else {
      if (type == 'goToPage') {
        this.selectedNumberPage = null;
      }
      idx = event;
    }

    this.pageIndex = 1;
    this.document.mainContractAttachments.forEach((file, index) => {
      if (file.fileName == this.fileUploads[idx].name) {
        this.activeFile = index;
      }
    });
    const file = this.createContractMohaService.fileUploadSrc.getValue();
    this.selectFile = this.fileUploads[idx];
    if (file.length) {
      this.pdfSrc = file[idx];
    }
  }


  changeDataToTable(){
    this.listDataSign.enterprise.map(res=>{
      let changeDataUser = this.listSign.filter(sign => sign.userId == res.userId)
      this.tranformDataUser(changeDataUser)
    })
    this.listDataSign.customer.map(res=>{
      let changeDataCustomer = this.listSign.filter(sign => sign.customerId == res.customerId)
      this.tranformDataUser(changeDataCustomer)
    })
    this.listApproverSign.map(res=>{
      let changeDataApprover = this.listSign.filter(sign => sign.userId == res.userId)
      this.tranformDataUser(changeDataApprover)
    })
    // sortData
    this.listSign.sort((a, b) => a.positionX - b.positionX);
    this.listSign.sort((a, b) => a.positionY - b.positionY);
    this.listSign.sort((a, b) => a.pageIndex - b.pageIndex);
    // render lai khung chan ky
    this.listSign.map(res=>{
      let idSign = (res.contractSignId || res.idNumber) +  '-sign-' + (res.enterpriseId || res.customerId) + '-approver-' + res.userId
      let sign = document.getElementById(idSign)
      if (sign) {
        this.getOffClose(res);
        const elements = sign.getElementsByTagName('div');
        if (elements.length) {
          if(res.row_number && this.stopClose){
            elements.item(0).textContent = `${this.message.getMessage('signature')} ${res.name} ${this.message.getMessage('number_sign')} ${res.row_number}`
          }
          else {elements.item(0).textContent = `${this.message.getMessage('signature')} ${res.name} `}
        }
      }
    })
  }

  tranformDataUser(data){
    this.sortData(this.fileUploads,data)
    return data
  }

  // Sap xep thu tu chan ky
  sortData(listFile, listSignSort){
    const getFileIndex = (fileId: string): number => {
      return listFile.findIndex((file) => file.id === fileId);
    };

    const listSign: any[] = [];

    if (Array.isArray(listSignSort)) {
      listSign.push(...listSignSort);
    }

    listSign.sort((a, b) => a.positionX - b.positionX);
    listSign.sort((a, b) => a.positionY - b.positionY);
    listSign.sort((a, b) => a.pageIndex - b.pageIndex);

    listSign.sort((prev, next) => {
      return (
        getFileIndex(prev.fileId) - getFileIndex(next.fileId)
      );
    });
    this.fileUploads.map((res: any)=>{
      let signFile = listSign.filter(sign => sign.fileId == res.id)
      signFile.forEach((row, index) =>{
        row.row_number = index +1;
    });
    })
    return listSign;
  }

  drop(event: CdkDragDrop<string[]>) {
    const filesSrc = this.createContractMohaService.fileUploadSrc.getValue();
    let arraySrcBeforeMoveFile = [...[]];
    let arraySrcAfterMoveFile = [...[]];

    this.document.mainContractAttachments.forEach((data, indexFileName) => {
      filesSrc.forEach((fileSrc, indexFileSrc) => {
        if(indexFileName === indexFileSrc) {
          arraySrcBeforeMoveFile.push({
            src: fileSrc,
            fileName: data.fileName
          });
        }
      })
    });

    const checkIndexFile = !!(this.activeFile === event.previousIndex);
    const activeFileOld = this.activeFile;

    moveItemInArray(this.document.mainContractAttachments, event.previousIndex, event.currentIndex);
    if(this.activeFile === event.previousIndex) {
      this.activeFile = event.currentIndex;
    } else if(event.previousIndex > this.activeFile && event.currentIndex <= this.activeFile) {
      this.activeFile = this.activeFile + 1;
    } else if(event.previousIndex < this.activeFile && event.currentIndex >= this.activeFile) {
      this.activeFile = this.activeFile - 1;
    } else {
      // console.log(this.document.mainContractAttachments)
    }
    this.document.mainContractAttachments = [...this.document.mainContractAttachments.map((file, index) => ({
      ...file,
      attachmentOrder: index
    }))];

    this.selectedFileSign = this.activeFile;
    this.selectedFile = '';
    this.selectedNumberPage = null;

    const filesUploadNew = [];
    this.document.mainContractAttachments.forEach((file) => {
      this.fileUploads.forEach((fileUpload) => {
        if(file.fileName === fileUpload.name) {
          filesUploadNew.push(fileUpload);
        }
      })
    });
    this.fileUploads = filesUploadNew;
    this.createContractMohaService.fileUploadArray.next(filesUploadNew);

    this.document.mainContractAttachments.forEach((data) => {
      arraySrcBeforeMoveFile.forEach((fileSrc) => {
        if(data.fileName === fileSrc.fileName) {
          arraySrcAfterMoveFile.push(fileSrc.src);
        }
      })
    });

    this.createContractMohaService.fileUploadSrc.next(arraySrcAfterMoveFile);
    for (let i=1; i <= this.maxPageCurrent; i++) {
      // console.log(`text-pdf-layer-${i}-${checkIndexFile ? event.previousIndex : this.activeFile}`)
      const element: any = document.getElementById(`text-pdf-layer-${i}-${checkIndexFile ? event.previousIndex : activeFileOld}`);
      if (element) {
        element.setAttribute('id', `text-pdf-layer-${i}-${this.activeFile}`);
      }
    }
    this.createContractMohaService.mainContractAttactment.next(this.document.mainContractAttachments);
    this.createContractMohaService.pdfSrc.next(arraySrcAfterMoveFile[0]);
    this.changeDataToTable()
    setTimeout(() => {
      const tabs = document.getElementsByClassName('tab');
      if (tabs) {
        Array.from({ length: tabs.length }, (v, i) => i).forEach(index => {
          const tab = tabs.item(index) as HTMLElement;
          tab.style.width = 100 / this.document.mainContractAttachments.length + '%';
        })
      }
    }, 0);
  }

  private renderTextContent(
    container: HTMLElement,
    text: unknown,
    contentStyle: string,
    options?: {
      closeIconSize?: number;
      contentClass?: string;
      notification?: { text: unknown; style: string };
    }
  ): void {
    while (container.firstChild) {
      container.removeChild(container.firstChild);
    }

    if (options && options.closeIconSize !== undefined) {
      const closeIcon = document.createElement('span');
      closeIcon.className = 'mat-icon material-icons';
      closeIcon.style.cssText = `font-size: ${options.closeIconSize}px; position: absolute; top: 0; right: 0; cursor: pointer; height: unset; width: unset; color: red;`;
      closeIcon.textContent = 'close';
      container.appendChild(closeIcon);
    }

    const content = document.createElement('div');
    content.style.cssText = contentStyle;
    if (options && options.contentClass) {
      content.className = options.contentClass;
    }
    if (options && options.notification) {
      const notification = document.createElement('div');
      notification.id = 'notify_outside';
      notification.style.cssText = options.notification.style;
      notification.textContent = String(options.notification.text == null ? '' : options.notification.text);
      content.appendChild(notification);
    }
    content.appendChild(document.createTextNode(String(text == null ? '' : text)));
    container.appendChild(content);
  }

}
